<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-4 col-12 align-items-center"
        >
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div>
              <h1 class="title-view">
                {{ $route.meta.title }}
                <FirstBookingBadge :isFirstBooking="isFirstBooking" />
              </h1>

              <div class="box-id">
                <span class="number-id"> {{ booking_number }} </span>
                <span class="ml-2 mr-2">|</span>
                <div class="status-tab" v-if="reservationStatus">
                  <TransferStatusBadge
                    :stage="stage"
                    :status="reservationStatus"
                    :updateStatus="updateStatus"
                    :pickupDate="pickupDate"
                    :createdAt="createdAt"
                    :timezone="timezone"
                  />

                  <span class="ml-2 mr-2">|</span>
                  <div class="status-payment">
                    <PaymentStatus
                      :paymentStatus="paymentStatus"
                      :paymentMethod="paymentMethod"
                      :paymentLinkStatus="paymentLinkStatus"
                      :paymentLink="paymentLink"
                      classes="badge-status px-0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xl-7 col-lg-7 col-md-6 col-sm-8 col-12 align-items-center alinmov2"
        >
          <div class="box-buttons">
            <div class="d-inline-block mr-1">
              <b-form-group v-slot="{ ariaDescribedbyview }">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="mode"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  button-variant="outline-neutral pc-4"
                >
                  <b-form-radio value="view">
                    <el-tooltip content="Expanded View" placement="bottom"
                      ><i class="flaticon-bold-menu mt-1"></i></el-tooltip
                  ></b-form-radio>
                  <b-form-radio value="list">
                    <el-tooltip content="List View" placement="bottom"
                      ><i class="flaticon-two mt-1"></i></el-tooltip
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <base-dropdown
              v-if="
                branch &&
                  reservation &&
                  (canUserChangeStatus ||
                    canUserMarkBookingAsPaid ||
                    canUserSendPaymentLink ||
                    canUserCreate)
              "
              menu-on-left
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-menu-1"></i>
                <strong class="d-lg-block d-none">Actions</strong>
              </base-button>
              <div
                class="dropdown-item"
                @click="openReservationHistory(reservationId, booking_number)"
              >
                <span class="icon-action">
                  <i class="flaticon-wall-clock-1 text-blue"></i>
                  View History
                </span>
              </div>
              <template v-if="stage === 'QUOTE'">
                <div
                  class="dropdown-item"
                  v-if="canConvertQuote(reservationStatus)"
                  @click="
                    convertToBooking(reservationId, convertQuoteToBookingById)
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-right-4 text-confirmed"> </i>
                    Convert to Reservation
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canDownloadQuotePDF(reservationStatus)"
                  @click="
                    downloadQuotePDF(
                      reservationId,
                      booking_number,
                      downloadQuoteById
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-web-bill-2"></i>Download Quote
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canDuplicateQuote(reservationStatus)"
                  @click="duplicateQuote(reservationId, duplicateQuoteById)"
                >
                  <span class="icon-action">
                    <i class="flaticon-copy"></i>Duplicate
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canCancelQuote(reservationStatus)"
                  @click="cancelQuote(reservationId, cancelQuoteById)"
                >
                  <span class="icon-action">
                    <i class="flaticon-remove text-cancelled"></i> Cancel
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  @click="deleteQuote(reservationId, deleteQuoteById)"
                >
                  <span class="icon-action">
                    <i class="flaticon-delete text-danger"></i>Delete
                  </span>
                </div>
              </template>
              <template v-else>
                <div
                  class="dropdown-item"
                  v-if="
                    canUserChangeStatus &&
                      canConfirmBooking(
                        reservationStatus,
                        updateStatus,
                        reservation.owner
                      )
                  "
                  @click="confirmBooking(reservationId, confirmBookingById)"
                >
                  <span class="icon-action">
                    <i class="flaticon-bold-check-3 text-confirmed"> </i>
                    Confirm
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="
                    canUserChangeStatus && canCancelBooking(reservationStatus)
                  "
                  @click="
                    handlerCancelReservation(
                      reservationId,
                      pickupDate,
                      branch.timezone,
                      cancellationPolicy,
                      cancelBookingById
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-remove text-cancelled"></i>
                    Cancel
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="
                    canUserChangeStatus &&
                      canCompleteBooking(reservationStatus) &&
                      calculateHoursDifference(pickupDate, branch.timezone) >= 1
                  "
                  @click="completeBooking(reservationId, updateBookingStatus)"
                >
                  <span class="icon-action">
                    <i class="flaticon-check text-completed"></i>
                    Complete
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="
                    canUserChangeStatus &&
                      canMarkBookingAsNoShow(reservationStatus) &&
                      calculateHoursDifference(pickupDate, branch.timezone) >= 1
                  "
                  @click="noShowBooking(reservationId, updateBookingStatus)"
                >
                  <span class="icon-action">
                    <i class="flaticon-no-group text-no-show"></i>
                    Mark as No Show
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="
                    canUserMarkBookingAsPaid &&
                      canMarkBookingAsPaid(reservationStatus, paymentStatus)
                  "
                  @click="
                    handlerMarkReservationsAsPaid(
                      [
                        {
                          _id: reservationId,
                          paymentLink: { status: paymentLinkStatus },
                          ...reservation
                        }
                      ],
                      markReservationsAsPaidById
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-web-credit-card text-confirmed"></i>
                    Mark as Pay
                  </span>
                </div>
                <div class="dropdown-divider"></div>
                <div
                  class="dropdown-item"
                  v-if="canUserSendPaymentLink"
                  @click="
                    handlerSendPaymentLink(
                      [
                        {
                          _id: reservationId,
                          paymentLink: { status: paymentLinkStatus },
                          payment_status: paymentStatus,
                          ...reservation
                        }
                      ],
                      customer,
                      sendPaymentLinkToCustomer
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-email text-orange"></i> Send Payment Link
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canResendBookingEmail(reservationStatus)"
                  @click="
                    resendNotifications(
                      reservationId,
                      reservationStatus,
                      bookingType,
                      isProcessing,
                      resendEmailNotificationByBookingId
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-envelope text-orange"></i> Resend Email
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canUserCreate"
                  @click="duplicateBooking(reservationId, duplicateBookingById)"
                >
                  <span class="icon-action">
                    <i class="flaticon-copy"></i>Duplicate
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canDownloadQuote(reservationStatus)"
                  @click="
                    downloadPDFType(
                      reservationId,
                      booking_number,
                      reservation.product,
                      'quote',
                      reservation.agent
                        ? reservation.agent
                        : reservation.customer
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-web-bill-2"></i>Download Quote
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-if="canDownloadVoucher(reservationStatus)"
                  @click="
                    downloadPDFType(
                      reservationId,
                      booking_number,
                      reservation.product,
                      'voucher',
                      reservation.agent
                        ? reservation.agent
                        : reservation.customer
                    )
                  "
                >
                  <span class="icon-action">
                    <i class="flaticon-web-bill-2"></i> Download Voucher
                  </span>
                </div>
              </template>
            </base-dropdown>

            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-plus"></i>
                <strong class="d-lg-block d-none">Add</strong>
              </base-button>
              <div class="dropdown-item" @click="openExtrasModal()">
                <span class="icon-action"> Add Extras </span>
              </div>

              <div class="dropdown-item" @click="openDiscountModal()">
                <span class="icon-action"> Add Discount </span>
              </div>
            </base-dropdown>

            <el-tooltip
              v-if="(mode === 'view' || mode === 'list') && canUserUpdate"
              :disabled="!editBlockedReason"
              :content="editBlockedReason"
              placement="bottom"
            >
              <span class="d-inline-block ml-2">
                <base-button
                  type="outline-secondary"
                  @click="mode = 'edit'"
                  class="min-button no-mb"
                  :disabled="!!editBlockedReason"
                >
                  <i class="flaticon-pencil icon-no-margin"></i>
                  <strong class="d-lg-block d-none">Edit</strong>
                </base-button>
              </span>
            </el-tooltip>

            <base-button
              type="primary"
              @click="storeReservation()"
              class="min-button ml-2 no-mb"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
          v-if="
            isRequoteNeeded ||
              reservation.childSeatsCount > 0 ||
              pendingChange ||
              isAvailabilityRequestPending
          "
        >
          <base-alert type="warning" class="mb-2 info-min">
            <i class="flaticon-warning mr-1"></i>

            <strong>Important!</strong>

            <ol class="pl-3 mb-0">
              <li v-if="isAvailabilityRequestPending">
                <span class="span-alert">
                  <strong>{{ availabilityRequestNotice.title }}</strong>
                  {{ availabilityRequestNotice.message }}
                </span>
              </li>
              <li v-if="pendingChangeNotice">
                <span class="span-alert">
                  <strong>{{ pendingChangeNotice.title }}</strong>
                  {{ pendingChangeNotice.message }}
                  <span
                    v-if="isPendingChangeAwaitingPayment"
                    class="curp"
                    @click="showPendingChangeModal = true"
                  >
                    <strong>Click here to review or cancel them.</strong></span
                  >
                </span>
              </li>
              <li v-if="isRequoteNeeded">
                <span class="span-alert">
                  <strong>Quote Expired:</strong> The quote period for this
                  reservation has expired. You can resume the reservation once
                  it has been re-quoted.
                  <span class="curp" @click="recalculateExpiredReservation()"
                    ><strong>Click here to re-quoted.</strong></span
                  ></span
                >
              </li>
              <li v-if="reservation.childSeatsCount > 0">
                <span class="span-alert" v-if="mode === 'edit'">
                  <strong>You are adding a child seat(s).</strong> You must
                  verify with the supplier that the requested child seat(s) can
                  be fulfilled. Even if child seats have no additional cost,
                  they must be registered as extras in the system with a price
                  of 20 USD/EUR once the supplier has confirmed availability. If
                  any additional costs apply, add the extra to the reservation
                  and contact the customer to process the payment. After adding
                  the extra, send a notification to the customer confirming the
                  update.
                </span>
                <span class="span-alert" v-else>
                  <strong> This reservation includes child seat(s). </strong>
                  Please ensure that the availability has been confirmed with
                  the supplier and that the child seat(s) have been correctly
                  added as extras. Child seats must appear as extras in the
                  charges. If any additional charges apply, the customer should
                  have been contacted and notified accordingly.
                </span>
              </li>
            </ol>
          </base-alert>
        </div>

        <div v-show="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{ getTitleByGender(passenger.gender) }}
                                {{ passenger.fullName }}</span
                              >

                              <span class="date-time">
                                {{ formatBookingDate(reservation.pickup_date) }}
                                at
                                {{ formatBookingTime(reservation.pickup_time) }}
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center"
                            >
                              <span class="label-total"> TOTAL CHARGES: </span>

                              <span
                                class="price-total"
                                :class="
                                  reservation.pricing.totals.gross_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  parsePrice(
                                    reservation.pricing.totals.gross_price
                                  )
                                }}
                                {{ currency.code }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12">
                        <div class="card-ticket">
                          <div
                            class="box box-services"
                            v-if="reservation.product"
                          >
                            <div class="row">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-experience-reserv">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <LazyImage
                                      :src="product.images[0] || noImage"
                                      :alt="`${product.name}`"
                                      imgClasses="img-experiences-min"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12 align-self-center"
                                  >
                                    <a
                                      :href="
                                        `/experiences/rhomtrip/${reservation.product}`
                                      "
                                      target="_blank"
                                      class="link-experiences mt-sm-0 mt-3"
                                    >
                                      {{ product.name
                                      }}<i class="flaticon-link ml-1 f-14"></i>
                                    </a>

                                    <div class="descrip">
                                      <p class="short-description">
                                        {{ product.shortdescription }}
                                      </p>

                                      <div class="d-flex">
                                        <span
                                          ><i class="flaticon-employees"></i>

                                          {{ product.passengers.maximum }}
                                          <i
                                            class="flaticon-briefcase ml-2"
                                          ></i>
                                          {{ product.bags.maximum }}

                                          <i
                                            class="flaticon-clock ml-2 mr-1"
                                            v-if="product.type === 'TOUR'"
                                          ></i>
                                          <span v-if="product.type === 'TOUR'">
                                            {{ product.durationValue }}
                                            {{
                                              getUnitTime(
                                                product.durationUnit,
                                                product.durationValue
                                              )
                                            }}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div class="col-12 p-0">
                                <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                  <div class="address-content">
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-start text-primary"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one"
                                        >Pickup:
                                        {{
                                          getFormatTime(reservation.pickup_time)
                                        }}
                                      </span>
                                      <span class="title-two">{{
                                        reservation.from
                                      }}</span>
                                    </div>
                                  </div>

                                  <div
                                    class="address-content mt-2"
                                    v-if="reservation.type !== 'hourly'"
                                  >
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-placeholder-1 text-success"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one">Dropoff </span>
                                      <span class="title-two">{{
                                        reservation.to
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="box box-services">
                            <div class="row" v-if="service !== null">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-serv-v card-select">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <img
                                      v-lazy="service.vehicle.image"
                                      class="img-fluid es-img-service"
                                      alt="Service Car"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-4 col-lg-5 col-md-5 col-sm-9 col-12 align-self-center alinmov4 pl-sm-0 pr-0 bord-left"
                                  >
                                    <h2 class="title-serv">
                                      {{
                                        formatServiceCategory(
                                          service.vehicle.category
                                        )
                                      }}

                                      {{ service.vehicle.seats }} seats
                                    </h2>

                                    <span class="type-card"
                                      >{{ service.vehicle.make_label }} or
                                      Similar</span
                                    >

                                    <div class="descrip">
                                      <span>
                                        <i class="flaticon-people-1"></i>
                                        PAX: {{ service.vehicle.seats }}
                                      </span>

                                      <span>
                                        <i class="flaticon-briefcase"></i>
                                        Bags: {{ service.vehicle.suitcases }}
                                      </span>
                                    </div>

                                    <div class="more-details">
                                      <ul class="mb-0">
                                        <li
                                          v-for="tag in service.vehicle.tags || []"
                                          :key="tag.ref"
                                        >
                                          {{ tag.name }}
                                        </li>

                                        <li v-if="service.preference.wifi">
                                          WiFi onboard
                                        </li>
                                        <li v-if="service.preference.water">
                                          Water
                                        </li>
                                        <li
                                          v-if="
                                            service.preference.hand_sanitizer
                                          "
                                        >
                                          Hand Sanitizer
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-12 alinmov8 align-self-center pl-lg-0"
                                  >
                                    <div class="box-driver" v-if="driver">
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>
                                      <div class="card-driver">
                                        <div class="content-image">
                                          <div
                                            class="img-driver"
                                            v-bind:style="{
                                              backgroundImage: `url('${driver.profile.image}')`
                                            }"
                                            v-if="driver.profile.image"
                                          ></div>

                                          <div
                                            v-else
                                            class="img-driver"
                                            :style="{
                                              backgroundImage:
                                                'url(' + imgprofile + ')'
                                            }"
                                          ></div>
                                        </div>

                                        <div class="content">
                                          <div class="item-content">
                                            <label>Driver: </label
                                            ><span
                                              >{{
                                                getTitleByGender(
                                                  driver.person.gender
                                                )
                                              }}
                                              {{ driver.person.first_name }}
                                              {{
                                                driver.person.last_name
                                              }}</span
                                            >
                                          </div>
                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.person
                                                .numbre_phone
                                            }"
                                          >
                                            <label>Phone: </label
                                            ><span
                                              ><a
                                                :href="
                                                  `tel:${driver.person.numbre_phone}`
                                                "
                                                >{{
                                                  driver.person.numbre_phone
                                                }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.person.numbre_phone
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i></span></el-tooltip
                                            ></span>
                                          </div>

                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.account.email
                                            }"
                                            v-if="driver.account.email"
                                          >
                                            <label>Email: </label>
                                            <span
                                              ><a
                                                class="break-data"
                                                :href="
                                                  `https://mail.google.com/mail/?view=cm&fs=1&to=${driver.account.email}`
                                                "
                                                >{{ driver.account.email }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.account.email
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i>
                                                </span>
                                              </el-tooltip>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="box-driver" v-else>
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>

                                      <base-alert
                                        type="warning"
                                        class="info-min text-center"
                                      >
                                        <i class="flaticon-warning mr-1"></i>
                                        <strong>No driver assigned!</strong>
                                        Wait for driver assignment
                                      </base-alert>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="service"
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 supplier-box"
                          >
                            <div class="item-content-2">
                              <label>Destination: </label
                              ><span class="ml-1">
                                {{ getBranchName(service.branchId) }}
                              </span>
                              <span class="mx-2 no-mobile-xxs">|</span>
                            </div>

                            <div class="item-content-2">
                              <label>Supplier: </label
                              ><span class="ml-1">
                                <a
                                  :href="`/suppliers/${service.supplierId}`"
                                  target="_blank"
                                >
                                  {{ getSupplierName(service.supplierId) }}
                                </a>
                                <el-popover
                                  placement="bottom"
                                  trigger="hover"
                                  width="300"
                                  class="curp d-inline-flex ml-1"
                                  v-if="getSupplierNotes(service.supplierId)"
                                >
                                  <span>
                                    <strong>Notes: </strong>
                                    <span class="text-min">
                                      {{ getSupplierNotes(service.supplierId) }}
                                    </span>
                                  </span>

                                  <div
                                    slot="reference"
                                    class="badge badge-note"
                                  >
                                    Note
                                  </div>
                                </el-popover>
                              </span>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Type Transfer</span>
                                  <span class="content-block">{{
                                    formatTransferType(reservation.type)
                                  }}</span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX N°</span>
                                  <span class="content-block"
                                    >{{ reservation.passengersCount }} PAX</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">
                                    {{ getTitleByGender(passenger.gender) }}
                                    {{ passenger.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block"
                                    >Contact Number</span
                                  >
                                  <span class="content-block"
                                    >{{ passenger.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="passenger.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                :class="{
                                  'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12':
                                    reservation.flight_number,
                                  'col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12': !reservation.flight_number
                                }"
                              >
                                <div class="data-block">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/${customer._id}`
                                          : `/customers/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        formatClientType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="reservation.type !== 'journey'"
                              >
                                <div class="data-block">
                                  <span class="title-block">
                                    {{
                                      formatTransportTypeLabel(reservation.type)
                                    }}
                                  </span>
                                  <TransportReference
                                    content-class="content-block"
                                    :reservation="reservation"
                                    :loading="loaderVerifyFlight"
                                    @track="getFlightsInformationByIdent"
                                  />
                                </div>
                              </div>

                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                v-if="reservation.flight_number && flight"
                              >
                                <FlightDetails mode="view" :flight="flight" />
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Pickup Sign</span>
                                  <div v-if="pdfDataUrl" class="content-block">
                                    <span
                                      class="link ml-0"
                                      @click="openPreviewPickup()"
                                    >
                                      <i class="flaticon-visualization mr-1"></i
                                      >File uploaded</span
                                    >
                                  </div>

                                  <div v-else>
                                    <span
                                      class="content-block"
                                      v-if="reservation.pickupSign.text"
                                      >{{ reservation.pickupSign.text }}</span
                                    >

                                    <span class="content-block" v-else
                                      >NONE</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="
                          reservation.childSeatsCount > 0 ||
                            reservation.special_requirements
                        "
                      >
                        <div class="card pb-2 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Extras</span>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="reservation.special_requirements"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Special Requirements</span
                                >
                                <span class="content-block">
                                  {{ reservation.special_requirements }}
                                </span>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="reservation.childSeatsCount > 0"
                            >
                              <div class="data-block">
                                <span class="title-block">Child Seats N°</span>
                                <span class="content-block"
                                  >{{ reservation.childSeatsCount }} Seats</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-12 mt-2"
                        v-if="reservation.passengers.length > 1"
                      >
                        <div class="card mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">PAX</span>
                          </div>
                          <div>
                            <b-table
                              hover
                              :items="reservation.passengers"
                              :fields="
                                getHeaderPassengerTable(
                                  fieldsPassengerView,
                                  reservation.type
                                )
                              "
                              sort-by.sync="fullname"
                              sort-desc.sync="true"
                              select-mode="single"
                              ref="tableviewpassengers"
                              sort-icon-left
                              responsive
                              show-empty
                              empty-filtered-text="There are no records matching your request"
                              empty-text="There are no records to show"
                            >
                              <template #cell(fullname)="data">
                                <span class="text-capitalize"
                                  >{{ getTitleByGender(data.item.gender) }}
                                  {{ data.item.firstName }}
                                  {{ data.item.lastName }}
                                </span>

                                <span
                                  class="badge-status badge-default mr-2"
                                  v-if="data.item.primary"
                                  >Primary</span
                                >
                              </template>

                              <template #cell(phone)="data">
                                <span v-if="data.item.phone">{{
                                  data.item.phone
                                }}</span>
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(email)="data">
                                <span v-if="data.item.email">
                                  {{ data.item.email }}
                                </span>
                                <span v-else> N/A</span>
                              </template>

                              <template #cell(itinerary)="data">
                                <span
                                  class="uppercase"
                                  v-if="data.item.flightNumber"
                                  >{{ data.item.flightNumber }}</span
                                >
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(type)="data">
                                {{ formatPassengerType(data.item.type) }}
                              </template>
                              <template #cell(notify)="data">
                                {{ data.item.notify ? "Yes" : "No" }}
                              </template>
                            </b-table>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.keyDetails"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Key Details</span>
                            <span class="content-block">
                              {{ service.keyDetails }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2" v-if="service">
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Cancellations Policies</span
                            >
                          </div>

                          <ul class="cancellations-list">
                            <li
                              v-for="(item,
                              index) in service.cancellationPolicy"
                              :key="`${index}`"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.termsConditions"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Terms and Conditions</span
                            >
                            <span class="content-block">
                              {{ service.termsConditions }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-12 mt-2">
                        <div class="card box-created">
                          <span>
                            <strong>Created: </strong>
                            {{ getFormatDate(createdAt) }} at
                            {{ getFormatTime(createdAt) }}
                            | By <strong>{{ responsibleName }}</strong
                            >-{{ responsiblePosition }}
                          </span>
                          <span
                            ><strong>Origin:</strong>
                            {{ getSourceOrigin(reservation.source) }} |
                            <strong> Service Provider:</strong>
                            {{ getServiceProvider(reservation.source) }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="product ? 'experience' : 'transfer'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  :operation="'edit'"
                  :mode="'view'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :status="reservationStatus"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(
                      reservation.service,
                      reservation.customer
                    )
                  "
                  :commissions="reservation.commissions"
                  :surcharges="reservation.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div
                    v-if="stage === 'RESERVATION' || confirmationReason !== null"
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                  >
                    <div class="card py-3">
                      <div class="row">
                        <div class="col-12">
                          <h2 class="subtitle mb-1">Payment Details</h2>

                          <div class="item-selected">
                            <span>
                              <strong>Payment Type: </strong>
                              {{
                                formatPaymentType(reservation.payment_type)
                              }}</span
                            >
                          </div>

                          <div
                            class="item-selected"
                            v-if="reservation.invoice_number"
                          >
                            <span>
                              <strong>Invoice N°: </strong>
                              {{ reservation.invoice_number }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="reservation.invoice_number"
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>

                          <div
                            class="item-selected"
                            v-if="reservation.payment_reference"
                          >
                            <span>
                              <strong>Payment Reference N°: </strong>
                              {{ reservation.payment_reference }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="
                                    reservation.payment_reference
                                  "
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="
                      reservation.booking_reference || reservation.deal_number
                    "
                  >
                    <div class="card card py-3">
                      <h2 class="subtitle mb-1">External References</h2>

                      <div
                        class="item-selected"
                        v-if="reservation.booking_reference"
                      >
                        <span>
                          <strong>Reservation Reference: </strong>
                          {{ reservation.booking_reference }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.booking_reference"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>

                      <div class="item-selected" v-if="reservation.deal_number">
                        <span>
                          <strong>Zoho Deal Number: </strong>
                          {{ reservation.deal_number }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.deal_number"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="reservationId"
                  >
                    <ReservationPaymentSummary
                      :key="paymentSummaryKey"
                      :reservationId="reservationId"
                      :paymentLink="paymentLink"
                      :paymentLinkStatus="paymentLinkStatus"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" v-show="mode === 'list'">
          <div class="card">
            <!-- {{ reservation }} -->
            <div class="review">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Address / Date & Time</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation ID:</label
                    >
                    <span>{{ booking_number }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation Type:</label
                    >
                    <span v-if="reservation.product">Experience</span>
                    <span v-else>Private Transfer</span>
                  </div>

                  <div v-if="reservation.product">
                    <label class="form-control-label pr-1">Experience:</label>
                    <span>{{ product.name }}</span>
                  </div>

                  <div
                    v-if="reservation.product && reservation.type === 'hourly'"
                  >
                    <label class="form-control-label pr-1">Duration:</label>
                    <span>{{ reservation.number_hourly }} Hours</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Type Transfer:</label
                    >
                    <span>{{ formatTransferType(reservation.type) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pick Up Date:</label>
                    <span>
                      {{ formatBookingDate(reservation.pickup_date) }}</span
                    >
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Pick Up Time:</label>
                    <span>
                      {{ formatBookingTime(reservation.pickup_time) }}</span
                    >
                  </div>

                  <div>
                    <label class="form-control-label pr-1">From:</label>
                    <span>{{ reservation.from }}</span>
                  </div>

                  <div v-if="reservation.type !== 'hourly'">
                    <label class="form-control-label pr-1">To:</label>
                    <span>{{ reservation.to }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX N°:</label>
                    <span>{{ reservation.passengersCount }} PAX</span>
                  </div>

                  <div>
                    <div v-if="reservation.type !== 'journey'">
                      <label class="form-control-label pr-1">
                        {{ formatTransportTypeLabel(reservation.type) }}
                      </label>
                      <TransportReference
                        link-class="text-link"
                        :reservation="reservation"
                        :loading="loaderVerifyFlight"
                        @track="getFlightsInformationByIdent"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Service / Supplier</h4>

                  <div>
                    <label class="form-control-label pr-1">Supplier:</label>
                    <span v-if="supplier !== null">
                      {{ getSupplierName(reservation.supplier) }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Destination:</label>
                    <span v-if="branch !== null">
                      {{ getBranchName(reservation.branch) }}</span
                    >
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Service Type:</label>
                    <span v-if="service !== null">
                      {{ formatServiceCategory(service.vehicle.category) }}
                      {{ service.vehicle.seats }} seats
                    </span>
                  </div>
                  <div v-if="service !== null">
                    <label class="form-control-label pr-1">Vehicle:</label>
                    <span v-if="service !== null">
                      {{ service.vehicle.make_label }} or Similar
                    </span>
                  </div>

                  <div
                    v-if="
                      service !== null &&
                        service.vehicle.tags &&
                        service.vehicle.tags.length
                    "
                  >
                    <label class="form-control-label pr-1">Tags:</label>
                    <span>
                      {{ getTagNames(service.vehicle.tags) }}
                    </span>
                  </div>

                  <div v-if="driver">
                    <label class="form-control-label pr-1">Driver:</label>
                    <span class="capitalize">
                      {{ getTitleByGender(driver.person.gender) }}
                      {{ driver.person.first_name }}
                      {{ driver.person.last_name }}
                    </span>
                  </div>
                  <div v-if="driver">
                    <label class="form-control-label pr-1"
                      >Driver's phone:</label
                    >
                    <span>
                      {{ driver.person.numbre_phone }}
                    </span>
                  </div>
                  <div v-if="driver">
                    <label class="form-control-label pr-1"
                      >Driver's email:</label
                    >
                    <span>
                      {{ driver.account.email }}
                    </span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">PAX / Customer</h4>

                  <div>
                    <label class="form-control-label pr-1">Customer:</label>

                    <span class="capitalize"
                      >{{ customer.first_name }} {{ customer.last_name }} -
                      {{ formatClientType(customer.type) }}</span
                    >
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX:</label>
                    <span class="capitalize">
                      {{ getTitleByGender(passenger.gender) }}
                      {{ passenger.fullName }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Email:</label>
                    <span>{{ passenger.email }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Contact Number:</label
                    >
                    <span>{{ passenger.phone }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pickup Sign:</label>

                    <span
                      v-if="pdfDataUrl"
                      class="link ml-0"
                      @click="openPreviewPickup()"
                      ><i class="flaticon-visualization mr-1"></i>File
                      uploaded</span
                    >

                    <span class="break-word" v-else>{{
                      reservation.pickupSign.text
                    }}</span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <div
                    v-if="
                      reservation.childSeatsCount > 0 ||
                        reservation.special_requirements
                    "
                    class="mb-4"
                  >
                    <h4 class="subtitle mb-2">Extras</h4>

                    <div v-if="reservation.special_requirements">
                      <label class="form-control-label pr-1"
                        >Special Requirements:</label
                      >
                      <span class="break-word">
                        {{ reservation.special_requirements }}
                      </span>
                    </div>

                    <div v-if="reservation.childSeatsCount > 0">
                      <label class="form-control-label pr-1"
                        >Child Seats N°:</label
                      >
                      <span class="break-word">
                        {{ reservation.childSeatsCount }} Seats
                      </span>
                    </div>
                  </div>

                  <h4 class="subtitle mb-2">Pricing / Payment</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Total Charges:</label
                    >
                    <span>
                      {{ currency.symbol }}
                      {{ parsePrice(reservation.pricing.totals.gross_price) }}
                      {{ currency.code }}
                    </span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Payment Type:</label>
                    <span>
                      {{ formatPaymentType(reservation.payment_type) }}</span
                    >
                  </div>

                  <div v-if="reservation.invoice_number">
                    <label class="form-control-label pr-1">Invoice N°:</label>
                    <span>{{ reservation.invoice_number }}</span>
                  </div>

                  <div v-if="reservation.payment_reference">
                    <label class="form-control-label pr-1"
                      >Payment Reference N°:</label
                    >
                    <span> {{ reservation.payment_reference }}</span>
                  </div>

                  <div v-if="reservation.deal_number">
                    <label class="form-control-label pr-1"
                      >Zoho Deal Number:</label
                    >
                    <span> {{ reservation.deal_number }}</span>
                  </div>

                  <div v-if="reservation.booking_reference">
                    <label class="form-control-label pr-1"
                      >Reservation Reference:</label
                    >
                    <span>{{ reservation.booking_reference }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service && service.keyDetails">
            <div class="data-block mb-2">
              <span class="title-block f-14">Key Details</span>
              <span class="content-block"> {{ service.keyDetails }}</span>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service">
            <div class="data-block mb-2">
              <span class="title-block f-14">Cancellations Policies</span>
            </div>

            <ul class="cancellations-list">
              <li
                v-for="(item, index) in service.cancellationPolicy"
                :key="`${index}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <div class="card pb-3 mb-0" v-if="service && service.termsConditions">
            <div class="data-block mb-2">
              <span class="title-block f-14">Terms and Conditions</span>
              <span class="content-block"> {{ service.termsConditions }}</span>
            </div>
          </div>
        </div>

        <div v-show="mode === 'edit'" class="forms">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12" v-if="product">
                    <ProductCard :product="product" source="RHOMTRIP" />
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-4">
                      <h2 class="subtitle">Type Transfer</h2>

                      <div
                        class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                      >
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="reservation.type"
                          :options="reservationOptions"
                          name="radios-btn-default"
                          buttons
                          value-field="value"
                          text-field="label"
                          button-variant="group-neutral"
                          tabindex="1"
                          class="buttons-type"
                          @change="changeReservationTransferType"
                        ></b-form-radio-group>
                      </div>

                      <div
                        class="d-xl-none d-lg-none d-md-none d-sm-none d-block"
                      >
                        <WSelect
                          placeholder="Reservation Type"
                          v-model="reservation.type"
                          filterable
                          id="reservationType"
                        >
                          <el-option
                            v-for="option in reservationOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>

                  <!-- address/date/time/ -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Address / Date & Time</h2>

                      <div class="row">
                        <div class="col-12">
                          <WSelect
                            label="From"
                            v-bind:class="{
                              'is-invalid': $v.reservation.from.$error
                            }"
                            id="from"
                            name="from"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationFrom"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.from.$model"
                            @change="selectFrom"
                            indexTab="2"
                            ref="from"
                            :focusact="true"
                            no-data-text="Search by destination or landmark"
                            clearable
                            markrequired
                            allText
                            :error="fromValidationMessage($v.reservation.from)"
                          >
                            <el-option
                              v-for="(location, index) in optionsFrom"
                              class
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-show="reservation.type !== 'hourly'"
                        >
                          <WSelect
                            label="To"
                            v-bind:class="{
                              'is-invalid': $v.reservation.to.$error
                            }"
                            id="to"
                            name="to"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationTo"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.to.$model"
                            @change="selectTo"
                            indexTab="3"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            markrequired
                            :error="toValidationMessage($v.reservation.to)"
                          >
                            <el-option
                              v-for="(location, index) in optionsTo"
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Date"
                            :error="
                              $v.reservation.pickup_date.$error
                                ? `Select Pickup Date`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'd-M-Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                                allowInput: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_date"
                              @input="getRatesWithThePickupDate"
                              id="date"
                              name="date"
                              placeholder="Pickup Date"
                              tabindex="4"
                              markrequired
                            ></flat-picker>
                          </base-input>
                        </div>

                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Time"
                            :error="
                              $v.reservation.pickup_time.$error
                                ? `Select Pickup Time`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'G:i K',
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: 'G:i K',
                                time_24hr: false,
                                wrap: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_time"
                              @input="getRatesWithThePickupTime"
                              id="time"
                              name="time"
                              placeholder="Pickup Time"
                              tabindex="5"
                            ></flat-picker>
                          </base-input>
                        </div>

                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                          <base-input
                            class
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.passengersCount.$model
                            "
                            label="PAX N°"
                            placeholder="PAX N°"
                            id="passengers"
                            name="passengers"
                            mode="integer"
                            indexTab="6"
                            markrequired
                            :error="
                              passengerCountValidationMessage(
                                $v.reservation.passengersCount
                              )
                            "
                            @input="getRatesWithTheNumberPassengers"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                          v-if="
                            ['airport', 'arrival', 'departure'].includes(
                              reservation.type
                            )
                          "
                        >
                          <FlightNumberInput
                            v-model="$v.reservation.flight_number.$model"
                            :pickupDate="reservation.pickup_date"
                            :pickupTime="reservation.pickup_time"
                            :flightType="getFlightType(reservation.type)"
                            :validation="$v.reservation.flight_number"
                            :airport="airport"
                            :airportName="
                              getAirportName(
                                reservation.type,
                                reservation.from,
                                reservation.to
                              )
                            "
                            @input="onFlightNumberInput"
                            @validation-state="handleValidationState"
                            @selectFlight="handleFlightSelection"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'station'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.number_stations.$model"
                            label="Rail Line"
                            id="rail_line"
                            name="rail_line"
                            placeholder="Rail Line"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.number_stations.$error
                                ? 'Enter a Valid Rail Line'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'port'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.cruise_line.$model"
                            label="Cruise Ship"
                            id="cruise_ship"
                            name="cruise_ship"
                            placeholder="Cruise Ship"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.cruise_line.$error
                                ? 'Enter a Valid Cruise Ship'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'hourly'"
                        >
                          <WSelect
                            class
                            v-bind:class="{
                              'is-invalid': $v.reservation.number_hourly.$error
                            }"
                            placeholder="Select Hourly"
                            v-model.trim="$v.reservation.number_hourly.$model"
                            @input="getRatesWithTheHourly"
                            id="number_hourly"
                            name="number_hourly"
                            indexTab="8"
                            label="Hourly"
                            @change="changeRouterReference"
                            :error="
                              $v.reservation.number_hourly.$error
                                ? 'Select an Hours'
                                : ''
                            "
                          >
                            <el-option
                              v-for="number in minimumSelect"
                              :value="number"
                              :label="number"
                              :key="number"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-if="reservation.flight_number && flight"
                        >
                          <FlightDetails mode="edit" :flight="flight" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- service/Supplier -->
                  <div class="col-xl-12" v-if="showRates">
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                        >
                          <h2 class="subtitle">Service / Supplier</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="serviceAux.length > 0"
                          >
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Supplier"
                                v-model="supplierFilter"
                                id="supplierFilter"
                                name="supplierFilter"
                                filterable
                                :loading="loading"
                                indexTab="10"
                                @change="changeSupplier"
                                label="Supplier"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="supplier in suppliersOptions"
                                  :value="supplier._id"
                                  :label="supplier.businessDetails.name"
                                  :key="supplier._id"
                                ></el-option>
                              </WSelect>
                            </div>
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Destination"
                                v-model="branchFilter"
                                id="branchFilter"
                                name="branchFilter"
                                filterable
                                indexTab="11"
                                @change="changeBranch"
                                label="Destination"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="branch in branchesAux"
                                  :value="branch._id"
                                  :label="branch.name"
                                  :key="branch._id"
                                ></el-option>
                              </WSelect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-xl-12">
                          <base-alert
                            v-if="loaderService == 'NOT_FOUND'"
                            type="danger"
                            class="mb-0 info-min"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Not Found!</strong> There are no services
                            available for your search. Check the from and to.
                          </base-alert>

                          <div class="container-services">
                            <div class="content-service">
                              <div v-if="loaderService === 'RESULTS'">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                  v-for="(element, index) in serviceAux"
                                  :key="index"
                                >
                                  <Services
                                    :suppliers="suppliersOptions"
                                    :branches="branchesOptions"
                                    :selected="
                                      getSelectServices(service, element)
                                    "
                                    :service="element"
                                    @selectService="processServiceSelection"
                                    :transferType="reservation.type"
                                    :hourly="reservation.number_hourly"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="loaderService === 'SEARCHING'">
                            <div class="text-center pt-0 pb-4">
                              <h4><strong>Finding services...</strong></h4>
                              <span class="loader-pin"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12" v-else>
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-7 align-self-center"
                        >
                          <h2 class="subtitle">Service / Supplier</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-5 text-right form-group-no-margin align-self-center"
                        >
                          <div class="service-filters">
                            <div class="col-filter">
                              <base-button
                                class="min-button"
                                type="outline-neutral"
                                @click="requote()"
                              >
                                <i class="flaticon-pencil mr-2"></i>
                                Edit
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="col-xl-12">
                            <div class="row">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                v-if="service !== null"
                              >
                                <Services
                                  :styleCard="'single'"
                                  :suppliers="suppliersOptions"
                                  :branches="branchesOptions"
                                  :selected="false"
                                  :service="service"
                                  :transferType="reservation.type"
                                  :hourly="reservation.number_hourly"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-8 align-self-center"
                        >
                          <h2 class="subtitle">Driver</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-4 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="driverEdit === 'view' && driverId !== ''"
                          >
                            <div class="col-filter">
                              <base-button
                                class="min-button"
                                type="outline-neutral"
                                @click="driverEdit = 'edit'"
                              >
                                <i class="flaticon-pencil mr-2"></i>
                                Edit
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="row"
                        v-if="driverEdit !== 'view' && driverId !== ''"
                      >
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            placeholder="Select Driver"
                            id="drivers_list"
                            name="driver_list"
                            v-model="driverId"
                            clearable
                            filterable
                            label="Driver"
                            @change="selectDriver"
                          >
                            <el-option
                              v-for="(item, index) in driversOptions"
                              :value="item._id"
                              :label="
                                `${item.person.first_name} ${item.person.last_name}`
                              "
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="showAddModalDriver = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>

                      <div class="row" v-if="driverId">
                        <div class="col-xl-12 mb-4">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-11 col-11 align-self-center"
                            >
                              <div class="box-card-lic">
                                <div class="card-person link-img-profile">
                                  <a
                                    :href="`/edit-driver/${driver._id}`"
                                    target="blank"
                                  >
                                    <div
                                      class="img-driver"
                                      v-bind:style="{
                                        backgroundImage: `url('${driver.profile.image}')`
                                      }"
                                      v-if="driver.profile.image"
                                    ></div>

                                    <div
                                      v-else
                                      class="img-driver"
                                      :style="{
                                        backgroundImage:
                                          'url(' + imgprofile + ')'
                                      }"
                                    ></div>
                                  </a>
                                  <div class="content">
                                    <div>
                                      <label>Driver: </label
                                      ><span
                                        >{{
                                          getTitleByGender(driver.person.gender)
                                        }}
                                        {{ driver.person.first_name }}
                                        {{ driver.person.last_name }}</span
                                      >
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="
                                            `${getTitleByGender(
                                              driver.person.gender
                                            )} ${driver.person.first_name} ${
                                              driver.person.last_name
                                            }`
                                          "
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </div>
                                    <div>
                                      <label>Phone: </label
                                      ><span
                                        ><a
                                          :href="
                                            `tel:${driver.person.numbre_phone}`
                                          "
                                          >{{ driver.person.numbre_phone }}</a
                                        >
                                      </span>
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="
                                            driver.person.numbre_phone
                                          "
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </div>
                                    <div v-if="driver.account.email">
                                      <label>Email: </label>
                                      <span
                                        ><a
                                          :href="
                                            `https://mail.google.com/mail/?view=cm&fs=1&to=${driver.account.email}`
                                          "
                                          target="_blank"
                                          >{{ driver.account.email }}</a
                                        >
                                      </span>
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="
                                            driver.account.email
                                          "
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 text-left pl-0 align-self-center"
                              v-if="driverEdit === 'edit'"
                            >
                              <el-tooltip content="Edit" placement="bottom">
                                <span
                                  class="icon-action text-blue mr-2 d-block"
                                  @click="showEditModalDriver = true"
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </span>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <AddDrivers
                        :show="showAddModalDriver"
                        :branchId="reservation.branch"
                        @close="closeNewDriverModal"
                        @input="addDriversInOptions"
                      />

                      <EditDrivers
                        :show="showEditModalDriver"
                        :driverId="driverId"
                        :driver="driver"
                        @close="closeEditDriverModal"
                        @change="updateDriversInOptions"
                      />
                    </div>
                  </div>

                  <!-- customer -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Customer</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.reservation.customer.$error
                            }"
                            class
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="customerId"
                            id="customer"
                            name="customer"
                            indexTab="13"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            :error="
                              $v.reservation.customer.$error
                                ? 'Enter a Customer'
                                : ''
                            "
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="getCustomerLabel(customer)"
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7 align-self-center">
                                  <span
                                    class="role-table"
                                    v-if="
                                      [
                                        'travel_agency',
                                        'travel_access'
                                      ].includes(customer.type)
                                    "
                                    >{{ customer.company_name }}</span
                                  >
                                  <span
                                    >{{ customer.first_name }}
                                    {{ customer.last_name }}</span
                                  >
                                </div>
                                <div
                                  class="col-5 text-right hide-data align-self-center"
                                >
                                  <span class="coin-right">{{
                                    formatClientType(customer.type)
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              tabindex="14"
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <AddCustomer
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        />
                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- passengers -->
                  <div class="col-xl-12">
                    <div class="card">
                      <div class="row mb-2">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-8 align-self-center"
                        >
                          <h2 class="subtitle mb-0">PAX</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-4 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            v-if="selectedRows.length > 0"
                            class="d-inline-block mr-2"
                          >
                            <base-button
                              v-if="
                                selectedRows.length > 0 &&
                                  !['BI', 'PNDG', 'SCB', 'SBC'].includes(
                                    reservationStatus
                                  )
                              "
                              type="outline-neutral mb-0"
                              @click="
                                sendNotificationToPassengers(selectedRows)
                              "
                              class="min-button btn-line-warning"
                            >
                              <i class="flaticon-envelope"></i>Send Notification
                            </base-button>
                          </div>
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button mb-0"
                            @click="importPassengers"
                          >
                            <i class="flaticon-up-2"></i> Import
                            <input
                              type="file"
                              ref="fileInput"
                              accept=".csv"
                              class="d-none"
                              @click.stop
                              @change="bulkPassengers"
                            />
                          </base-button>
                          <base-button
                            class="min-button mb-0"
                            type="outline-neutral"
                            @click="addNewPassenger"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>

                      <NewPassenger
                        :show="showNewPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :passengers="passengers"
                        :passengersIncluded="reservation.passengers"
                        :maxPassengers="
                          reservation.passengersCount
                            ? reservation.passengersCount
                            : 0
                        "
                        :transferType="reservation.type"
                        @addPassenger="addPassenger"
                        @close="closeNewPassengerModal"
                      />
                      <EditPassenger
                        :show="showEditPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :transferType="reservation.type"
                        :tempPassenger="tempPassenger"
                        @changePassenger="upadtePassenger"
                        @close="closeEditPassengerModal"
                      />

                      <div
                        class="mb-4"
                        v-if="reservation.passengers.length === 0"
                      >
                        <base-alert type="warning" class="mb-1 info-min">
                          <i class="flaticon-warning mr-1"></i> There are no PAX
                          here
                        </base-alert>
                      </div>
                      <div
                        class="list-card"
                        v-if="reservation.passengers.length === 1"
                      >
                        <div
                          class="card card-min"
                          v-for="(element, index) in reservation.passengers"
                        >
                          <div class="row">
                            <div
                              class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 align-self-center"
                            >
                              <div class="row">
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <div>
                                      <span class="content-block"
                                        ><strong>Full Name:</strong>
                                        {{ getTitleByGender(element.gender) }}
                                        {{ element.firstName }}
                                        {{ element.lastName }}
                                      </span>

                                      <span
                                        v-if="element.phone"
                                        class="content-block"
                                        ><strong>Contact Number:</strong>
                                        {{ element.phone }}
                                        <el-tooltip
                                          content="Copy"
                                          placement="bottom"
                                        >
                                          <span
                                            class="curp ml-2"
                                            v-clipboard:copy="element.phone"
                                            v-clipboard:success="onCopy"
                                            v-clipboard:error="onErrorCopy"
                                          >
                                            <i
                                              class="flaticon-copy link ml-0"
                                            ></i></span
                                        ></el-tooltip>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <span
                                      v-if="element.email"
                                      class="content-block"
                                      ><strong>Email:</strong>
                                      {{ element.email }}
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="element.email"
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </span>
                                    <span class="content-block"
                                      ><strong>Segment:</strong>
                                      {{ formatPassengerType(element.type) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 align-self-center alinmov6"
                            >
                              <el-tooltip
                                content="Edit"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="
                                    openEditPassengerModal(element, index)
                                  "
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </span>
                              </el-tooltip>

                              <el-tooltip
                                content="Copy data"
                                placement="bottom"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="copyPassengerData(element)"
                                >
                                  <i class="flaticon-copy text-black"></i>
                                </span>
                              </el-tooltip>

                              <el-tooltip
                                content="Send notification"
                                placement="bottom"
                              >
                                <span
                                  class="icon-action"
                                  v-if="
                                    !['BI', 'PNDG', 'SCB', 'SBC'].includes(
                                      reservationStatus
                                    )
                                  "
                                  @click.stop="
                                    sendNotificationToPassengers([element])
                                  "
                                >
                                  <i
                                    class="flaticon-envelope text-warning mr-2"
                                  ></i>
                                </span>
                              </el-tooltip>

                              <el-tooltip
                                content="Remove"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action"
                                  @click.stop="
                                    removePassenger(index, element.primary)
                                  "
                                >
                                  <i class="flaticon-cancel text-danger"></i>
                                </span>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="w-100">
                        <b-table
                          hover
                          :items="reservation.passengers"
                          :fields="
                            getHeaderPassengerTable(
                              fieldsPassenger,
                              reservation.type
                            )
                          "
                          sort-by.sync="fullname"
                          sort-desc.sync="true"
                          selectable
                          @row-selected="onRowSelected"
                          select-mode="multi"
                          ref="selectableTable"
                          sort-icon-left
                          responsive
                          show-empty
                          empty-filtered-text="There are no records matching your request"
                          empty-text="There are no records to show"
                        >
                          <template #cell(fullname)="data">
                            <span class="text-capitalize"
                              >{{ getTitleByGender(data.item.gender) }}
                              {{ data.item.firstName }}
                              {{ data.item.lastName }}
                            </span>

                            <span
                              class="badge-status badge-default mr-2"
                              v-if="data.item.primary"
                              >Primary</span
                            >
                          </template>

                          <template #cell(phone)="data">
                            <span v-if="data.item.phone">{{
                              data.item.phone
                            }}</span>
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(email)="data">
                            <span
                              class="hide-data lower"
                              v-if="data.item.email"
                            >
                              {{ data.item.email }}
                            </span>
                            <span v-else> N/A</span>
                          </template>

                          <template #cell(itinerary)="data">
                            <span
                              class="uppercase"
                              v-if="data.item.flightNumber"
                              >{{ data.item.flightNumber }}</span
                            >
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(type)="data">
                            {{ formatPassengerType(data.item.type) }}
                          </template>
                          <template #cell(notify)="data">
                            {{ data.item.notify ? "Yes" : "No" }}
                          </template>
                          <template #cell(actions)="data">
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="
                                  openEditPassengerModal(data.item, data.index)
                                "
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark as primary"
                              placement="bottom"
                              v-if="!data.item.primary"
                            >
                              <span
                                class="icon-action mr-2"
                                @click.stop="makePassengerAsDefault(data.index)"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Copy data" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="copyPassengerData(data.item)"
                              >
                                <i class="flaticon-copy text-black"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Send notification"
                              placement="bottom"
                            >
                              <span
                                class="icon-action"
                                v-if="
                                  !['BI', 'PNDG', 'SCB', 'SBC'].includes(
                                    reservationStatus
                                  )
                                "
                                @click.stop="
                                  sendNotificationToPassengers([data.item])
                                "
                              >
                                <i
                                  class="flaticon-envelope text-warning mr-2"
                                ></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Remove" placement="bottom">
                              <span
                                class="icon-action"
                                @click.stop="
                                  removePassenger(data.index, data.item.primary)
                                "
                              >
                                <i class="flaticon-cancel text-danger"></i>
                              </span>
                            </el-tooltip>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle">Pickup Sign</h2>

                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 align-self-center"
                        >
                          <div v-if="pdfDataUrl">
                            <div class="pdfPreview mb-4">
                              <iframe
                                :src="pdfDataUrl"
                                width="235px"
                                height="160px"
                                frameborder="0"
                                allowfullscreen
                                class="pdf-iframe"
                                scrolling="no"
                              ></iframe>

                              <el-tooltip
                                content="Open / Expand"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-expand"
                                  @click="openPreviewPickup()"
                                >
                                  <i class="flaticon-expand"></i></div
                              ></el-tooltip>

                              <el-tooltip
                                content="Remove Pickup Sign"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-remove"
                                  @click="clearfile()"
                                >
                                  <i class="flaticon-delete"></i></div
                              ></el-tooltip>
                            </div>
                          </div>

                          <el-input
                            v-else
                            v-model="reservation.pickupSign.text"
                            placeholder="Pickup Sign"
                            id="pickupSign"
                            name="pickupSign"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                          v-if="!pdfDataUrl"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button"
                            @click="uploadPickupSign"
                          >
                            <i class="flaticon-up-2"></i> Upload Pickup Sign
                            <input
                              type="file"
                              ref="pickupSign"
                              accept=".pdf"
                              model="pickupSign"
                              @change="readPickupSign"
                              class="d-none"
                            />
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-3">Extras</h2>

                      <div class="row">
                        <div
                          class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                        >
                          <label class="title-label" for="specialrequirements"
                            >Special Requirements</label
                          >
                          <el-input
                            v-model="reservation.special_requirements"
                            placeholder="Special Requirements"
                            id="Special Requirements"
                            name="Special Requirements"
                            maxlength="500"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 10 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.childSeatsCount.$model
                            "
                            mode="integer"
                            label="Child Seats N°"
                            id="child_seat"
                            name="child_seat"
                            placeholder="Child Seat"
                            indexTab="7"
                            :error="
                              childSeatsCountValidationMessage(
                                $v.reservation.childSeatsCount
                              )
                            "
                          />
                        </div>

                        <div
                          class="col-12 mt-0 mb-4"
                          v-if="reservation.childSeatsCount > 0"
                        >
                          <base-alert type="warning" class="mb-0 info-min">
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Important!</strong>
                            <span class="span-alert">
                              <strong>You are adding a child seat(s)</strong>
                              You must verify with the supplier that the
                              requested child seat(s) can be fulfilled. Even if
                              child seats have no additional cost, they must be
                              registered as extras in the system with a price of
                              20 USD/EUR once the supplier has confirmed
                              availability. If any additional costs apply, add
                              the extra to the reservation and contact the
                              customer to process the payment. After adding the
                              extra, send a notification to the customer
                              confirming the update.
                            </span>
                          </base-alert>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-12">
                    <div class="card box-created">
                      <span>
                        <strong>Created: </strong>
                        {{ getFormatDate(createdAt) }} at
                        {{ getFormatTime(createdAt) }}
                        | By <strong>{{ responsibleName }}</strong
                        >-{{ responsiblePosition }}
                      </span>
                      <span
                        ><strong>Channel:</strong>
                        Mobility Internal |
                        <strong> Service Provider:</strong> RhomTrip</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="product ? 'experience' : 'transfer'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  :operation="'edit'"
                  :mode="'edit'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :status="reservationStatus"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(
                      reservation.service,
                      reservation.customer
                    )
                  "
                  :commissions="reservation.commissions"
                  :surcharges="reservation.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div
                    v-if="stage === 'RESERVATION'"
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
                  >
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">Payment Details</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <WSelect
                            placeholder="Payment Type"
                            v-model="reservation.payment_type"
                            id="paymentType"
                            name="paymentType"
                            @change="changePaymentType"
                            label="Payment Type"
                          >
                            <el-option
                              v-for="option in paymentMethods"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <base-input
                            v-model.trim="reservation.invoice_number"
                            type="text"
                            label="Invoice Number"
                            placeholder="Invoice Number"
                            id="invoice_number"
                            name="invoice_number"
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        >
                          <base-input
                            type="text"
                            label="Payment Reference N°"
                            placeholder="Payment Reference N°"
                            v-model="reservation.payment_reference"
                            id="paymentreference"
                            name="paymentreference"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Reservation Reference"
                            placeholder="Reservation Reference"
                            v-model="$v.reservation.booking_reference.$model"
                            id="booking_reference"
                            name="booking_reference"
                            indexTab="28"
                            :error="
                              $v.reservation.booking_reference.$error
                                ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-7 col-sm-7 col-12"
                        >
                          <base-input
                            placeholder="Zoho Deal Number"
                            v-model.trim="$v.reservation.deal_number.$model"
                            id="deal_number"
                            name="deal_number"
                            label="Zoho Deal Number"
                            type="text"
                            :error="
                              dealNumberValidationMessage(
                                $v.reservation.deal_number
                              )
                            "
                          ></base-input>
                        </div>
                        <div
                          class="col-xl-12 col-lg-6 col-md-7 col-sm-7 col-12"
                        >
                          <WSelect
                            label="Event"
                            placeholder="Select Event"
                            v-model="reservation.event"
                            filterable
                            clearable
                            id="event"
                            name="event"
                            class="mb-0"
                          >
                            <el-option
                              v-for="option in eventOptions"
                              :value="option.value"
                              :label="option.label"
                              :key="option.value"
                            ></el-option>
                          </WSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ManageExtraCharges
      :show="showExtrasModal"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :extras="reservation.pricing.extras"
      :currency="currency"
      @change="manageExtras"
      @close="closeExtrasModal"
    />
    <ManageDiscounts
      :show="showDiscountModal"
      :grossPrice="reservation.pricing.totals.gross_price"
      :discounts="reservation.pricing.discounts"
      :currency="currency"
      @change="manageDiscounts"
      @close="closeDiscountModal"
    />
    <RequestRecipients
      :show="showRequestRecipients"
      @onPopulateRecipients="populateRecipients"
      @onCloseRequestRecipients="closeRequestRecipientsModal"
    />
    <PendingChangeModal
      v-if="isPendingChangeAwaitingPayment"
      :show="showPendingChangeModal"
      :reservationId="reservationId"
      :pendingChange="pendingChange"
      :originalReservation="reservationCopy"
      :originalService="serviceCopy"
      :currency="currency"
      :currencyCode="currency.code"
      :currencySymbol="currency.symbol"
      @close="showPendingChangeModal = false"
      @cancelled="onPendingChangeCancelled"
    />
    <ReservationHistory
      :show="showReservationHistory"
      :tempReservationId="tempReservationId"
      :bookingNumber="tempBookingNumber"
      @close="closeReservationHistoryModal"
    />
    <ManagePriceAdjustments
      :show="showPriceAdjusments"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :pricing="reservation.pricing"
      :lastGrossPrice="lastGrossPrice"
      :lastNetPrice="lastNetPrice"
      :currency="currency"
      @change="managePriceAdjusments"
      @close="closePriceAdjusments"
    />
    <ConfirmChanges
      v-if="showConfirmChanges"
      :show="showConfirmChanges"
      :original-details="originalDetails"
      :requested-details="requestedDetails"
      @close="onCancelConfirmChanges"
      @confirm-changes="onConfirmChanges"
    />

    <modal
      v-if="pdfDataUrl"
      :show.sync="showPreviewPickupSign"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pt-1"
    >
      <template slot="header">
        <h4 class="subtitle mb-0" id="BlackoutDate">Pickup Sign</h4>
      </template>

      <iframe
        :src="`${pdfDataUrl}#zoom=100`"
        width="100%"
        height="600px"
      ></iframe>
    </modal>
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
moment.suppressDeprecationWarnings = true;
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  ReservationsAPI,
  CountriesAPI,
  FlightsAPI,
  PassengersAPI,
  QuotesAPI,
  PaymentsAPI
} from "../../../../core/api/index.js";
import { joinTagNames } from "../../../../core/services/tags.service";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomer from "@/components/transfer/AddCustomer.vue";
import AddDrivers from "../../components/AddDriver.vue";
import EditDrivers from "../../components/EditDriver.vue";
import RequestRecipients from "../../components/RequestRecipients.vue";
import ReservationHistory from "../../components/ReservationHistory.vue";
import ReservationPaymentSummary from "../../components/ReservationPaymentSummary.vue";
import PendingChangeModal from "../../components/PendingChangeModal.vue";
import NewPassenger from "@/components/passengers/NewPassenger.vue";
import EditPassenger from "@/components/passengers/EditPassenger.vue";
import Charges from "@/components/price-composition/Charges.vue";
import ManageExtraCharges from "@/components/price-composition/ManageExtraCharges.vue";
import ManageDiscounts from "@/components/price-composition/ManageDiscounts.vue";
import ManagePriceAdjustments from "@/components/price-composition/ManagePriceAdjustments.vue";
import Services from "@/components/transfer/Services.vue";
import FlightNumberInput from "@/components/transfer/flightValidation/FlightNumberInput.vue";
import FlightDetails from "@/components/transfer/flightValidation/FlightDetails.vue";
import ConfirmChanges from "@/components/modals/confirmChanges.vue";
import {
  required,
  minLength,
  maxLength,
  alphaNum,
  minValue,
  maxValue,
  numeric,
  decimal,
  integer,
  requiredIf
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect,
  MessageBox,
  Message
} from "element-ui";
import { cloneDeep, isEqual } from "lodash";
import ProductCard from "../../components/ProductCard.vue";
import PaymentStatus from "../../components/PaymentStatus.vue";
import FirstBookingBadge from "../../components/FirstBookingBadge.vue";
import TransferStatusBadge from "../../components/TransferStatusBadge.vue";
import TransportReference from "../../components/TransportReference.vue";
import { FadeTransition } from "vue2-transitions";
import Papa from "papaparse";
import {
  PAYMENT_METHODS,
  RESERVATION_OPTIONS,
  RESERVATION_TYPES,
  canConfirmBooking,
  canCancelBooking,
  canCompleteBooking,
  canMarkBookingAsNoShow,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  confirmBooking,
  completeBooking,
  noShowBooking,
  markReservationsAsPaid,
  resendNotifications,
  duplicateBooking,
  canDownloadVoucher,
  canDownloadQuote,
  calculateHoursDifference,
  hasPaidBookings,
  hasCanceledBookings,
  hasExpiredBookings,
  hasBookingsWithPaymentLink,
  cancelBooking,
  sendPaymentLink,
  hasDraftBookings,
  isSameUserForAllBookings,
  getAirportDetails,
  populateFromOptions,
  populateToOptions,
  getAirportName,
  getFormatDate,
  getFormatTime,
  getFlightType,
  resolveRefundEligibility,
  hasPendingCapturePayment,
  confirmImportPassengers
} from "../../../../helpers/reservation.helpers";
import {
  validateHeadersFile,
  parseContentFile,
  getPassengerToRegister
} from "../../../../core/services/passenger.service";
import {
  calculateCommissionAmount,
  calculateTotalDiscounts,
  calculateTotalExtraGrossPrice,
  calculateTotalExtrasNetPrice,
  calculateTotalGrossPrice,
  calculateTotalNetPrice,
  calculateTotalNetProfit,
  getCommissionByCustomer
} from "../../../pricing";
import {
  generateMessageToNotify,
  getPickupDate,
  getPickupTime
} from "../../services/flight.service";

import {
  setSigOut,
  goBack,
  isPartner,
  isUserAuthorized,
  isUnauthorizedError
} from "../../../../helpers/commons.helpers";
import { FileService } from "../../../../core/services";
import {
  dealNumberValidationMessage,
  fromValidationMessage,
  childSeatsCountValidationMessage,
  passengerCountValidationMessage,
  toValidationMessage,
  validateContentFile
} from "../../services/validation.service";
import {
  calculateTotalPrice,
  isSamePriceComposition,
  isSameSurchargesComposition
} from "../../../pricing";
import debounce from "lodash.debounce";
import {
  formatClientType,
  formatPassengerType,
  formatPaymentType,
  formatPosition,
  formatServiceCategory,
  formatTransferType,
  formatTransportTypeLabel,
  formatBookingDate,
  formatBookingTime,
  getIcon,
  getCustomerLabel,
  parsePrice,
  getTitleByGender,
  getLabelToHeaderTable,
  getHeaderPassengerTable,
  adjustHeight,
  getContactNumber,
  getUnitTime,
  getSourceOrigin,
  getServiceProvider,
  getResponsibleName,
  getResponsiblePosition
} from "../../services/format.service";
import {
  canBeRequoted,
  isRequoteBlockedByStatus,
  handleCutOffConfirmation,
  handleBlackoutConfirmation,
  buildUtcPickupDateTime,
  getTypeLocation,
  getOriginData,
  getDestinationData,
  getServiceById,
  conversionCurrency,
  calculateGroosPrice,
  getGroosPrice,
  getReservationType,
  getRouterReferenceValue,
  getRouterReference,
  getSelectServices,
  getAdjustmentsStatus,
  driverAssign,
  getPoint
} from "../../services/quote.service";
import {
  populateProduct,
  populateAgent,
  populateCustomer,
  populateDriver,
  populateService,
  parsePassengers,
  getPickupSignByPrimaryPassenger,
  getCustomerById,
  getAgentId
} from "../../services/populate.service";
import { alphabeticallySort, hasChanges } from "../../services/client.service";
import { loadEventOptions } from "../../services/event.service";
import {
  FIELDS_PASSENGER,
  FIELDS_PASSENGER_VIEW,
  MINIMUM_SELECT
} from "../../../../core/constants";
import {
  canCancelQuote,
  canConvertQuote,
  canDownloadQuotePDF,
  canDuplicateQuote,
  cancelQuote,
  convertToBooking,
  deleteQuote,
  downloadQuotePDF,
  duplicateQuote
} from "@/helpers/quote.helpers";
import {
  CAPTURE_MODE_IMMEDIATE,
  CAPTURE_MODE_DEFERRED,
  EDIT_BLOCKED_REASONS,
  PAYMENT_METHOD,
  QUOTE_TYPES,
  RESERVATION_NOTICES
} from "../../constants/reservation.constants.js";
import { TransferPricingAPI } from "../../../../core/api/transfer-pricing.api.js";
import {
  toTransferDetails,
  requiresChangeConfirmation
} from "../../services/changes.service";
export default {
  name: "EditReservation",
  data() {
    return {
      eventOptions: [],
      reservation: {
        from: "",
        to: "",
        pickup_date: "",
        pickup_time: "",
        passengersCount: 0,
        childSeatsCount: 0,
        type: "arrival",
        supplier: null,
        branch: null,
        service: null,
        driver: null,
        vehicle: null,
        payment_type: "card",
        flight_number: "",
        customer: null,
        booking_reference: "",
        pickupSign: {
          format: "CUSTOM",
          text: "",
          link: ""
        },
        special_requirements: "",
        status: "",
        number_hourly: 0,
        invoice_number: 0,
        number_stations: "",
        cruise_line: "",
        surcharges: [],
        locations: {
          from: {
            lat: 0,
            lng: 0
          },
          to: {
            lat: 0,
            lng: 0
          }
        },
        distancematrix: {
          distance: 0,
          duration: 0
        },
        originData: null,
        destinationData: null,
        agent: null,
        product: null,
        passenger: null,
        metadata: {},
        deal_number: "",
        event: null,
        pricing: {
          net_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          base_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          gross_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          net_profit: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          sale_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          discounts: [],
          extras: [],
          totals: {
            discounts: 0.0,
            extras: {
              gross_price: 0.0,
              net_price: 0.0,
              net_profit: 0.0
            },
            net_price: 0.0,
            gross_price: 0.0,
            net_profit: 0.0
          },
          reason_adjustment: ""
        },
        chauffeur: {
          name: "",
          email: "",
          phone: "",
          gender: ""
        },
        passengers: [],
        notificaition: {
          configTag: "rhomtrip_internal",
          configRef: null
        },
        commissions: {
          payment_processor: {
            amount: 0.0,
            percentage: 0.0
          },
          platform: {
            amount: 0.0,
            percentage: 0.0
          }
        },
        source: {
          origin: "RhomTrip Internal",
          type: "INTERNAL",
          provider: "RHOMTRIP",
          channel: "SYSTEM",
          medium: "APP"
        },
        owner: "",
        flight: null
      },
      pickup_date: "",
      paymentMethods: PAYMENT_METHODS,
      reservationOptions: RESERVATION_OPTIONS,
      services: [],
      serviceAux: [],
      all_services: [],
      branchesAux: [],
      booking_number: "",
      isFirstBooking: false,
      customer: {
        currency: {
          code: "",
          symbol: "",
          label: ""
        },
        credit: {
          status: false,
          limit: 0,
          available: 0
        },
        _id: "",
        first_name: "",
        last_name: "",
        company_name: "",
        mark_up: 32,
        type_markup: "",
        email: "",
        phone: "",
        type: ""
      },
      minimumSelect: MINIMUM_SELECT,
      suppliersOptions: [],
      branchesOptions: [],
      supplierFilter: "",
      branchFilter: "",
      supplier: null,
      branch: null,
      loading: false,
      optionsFrom: [],
      customers: [],
      optionsTo: [],
      service: null,
      requestType: "one_way",
      reservationCopy: {},
      currency: {
        symbol: "",
        code: ""
      },
      copyData: false,
      serviceCopy: null,
      showConfirmChanges: false,
      redirectTo: null,
      originalDetails: {},
      requestedDetails: {},
      driversOptions: [],
      driver: null,
      country_code: "",
      modalCustomer: false,
      reservationId: null,
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      originData: null,
      destinationData: null,
      loaderService: "SEARCHING",
      onLoad: true,
      showRates: false,
      timeoutId: null,
      debouncedRequote: null,
      customerId: null,
      types: RESERVATION_TYPES,
      imgprofile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      product: null,
      showRequestRecipients: false,
      route: null,
      mode: "view",
      createdAt: "",
      showDiscountModal: false,
      showExtrasModal: false,
      paymentLinkStatus: "",
      paymentLink: "",
      responsibleName: "",
      responsiblePosition: "",
      driverEdit: "view",
      showAddModalDriver: false,
      showEditModalDriver: false,
      driverId: null,
      showNewPassengerModal: false,
      fieldsPassenger: FIELDS_PASSENGER,
      passengers: [],
      showEditPassengerModal: false,
      selectedRows: [],
      tempPassenger: null,
      passengerIndex: null,
      fieldsPassengerView: FIELDS_PASSENGER_VIEW,
      showPriceAdjusments: false,
      lastGrossPrice: 0,
      lastNetPrice: 0,
      updateStatus: false,
      pdfDataUrl: null,
      showPreviewPickupSign: false,
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      routerReference: {
        transferType: "arrival",
        value: ""
      },
      onSave: false,
      isProcessing: false,
      bookingType: "Transfers",
      cancellationPolicy: {},
      requoteStatus: "CALCULATED",
      loading: false,
      flightType: "NONE",
      flight: null,
      airport: null,
      flightValidationRoles: {},
      loaderVerifyFlight: false,
      reservationStatus: "",
      stage: "RESERVATION",
      confirmationReason: null,
      paymentStatus: "UNPAID",
      paymentMethod: null,
      oldGrossPrice: 0,
      pendingChange: null,
      showPendingChangeModal: false,
      paymentSummaryKey: 0
    };
  },
  watch: {
    "reservation.supplier": function(newValue, oldValue) {
      if (newValue !== "" && newValue !== null) {
        let supplier = this.suppliersOptions.find(
          element => element._id === newValue
        );
        if (supplier !== undefined) {
          this.supplier = supplier;
        }
      }
    },
    "reservation.branch": function(newValue, oldValue) {
      if (newValue !== "" && newValue !== null) {
        let branch = this.branchesOptions.find(
          branch => branch._id === newValue
        );
        if (branch !== undefined) {
          this.branch = branch;
        }
      }
    },
    customerOptions: {
      handler: function(current, old) {
        this.customers = current;
      },
      deep: true
    }
  },
  async created() {
    this.debouncedRequote = debounce(this.requote, 500);
    this.setItemsBread(this.$route.meta.bread);
    this.getSesion();
    this.setLoad(true);
    this.reservationId = this.$route.params.id;
    await this.loadReservation(this.reservationId);
    this.eventOptions = await loadEventOptions(
      this.sesion.token,
      this.reservation.event
    );
    this.customers = this.customerOptions;
    this.setLoad(false);
    setTimeout(() => {
      this.onLoad = false;
    }, 1500);
  },
  methods: {
    /**
     * Get the names of the vehicle tags to display them in a single line.
     * @param {Object[]} tags - The vehicle tags ({ ref, name, slug }).
     * @returns {string} The tag names separated by " | ".
     */
    getTagNames(tags = []) {
      return joinTagNames(tags);
    },
    // <<<<<<<<<<<<<<<<<<<< Booking & Quote Action Helpers >>>>>>>>>>>>>>>>>>>>
    openReservationHistory(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    onConfirmChanges() {
      this.showConfirmChanges = false;
      this.saveReservation({
        redirectTo: this.redirectTo,
        customer: this.customer
      });
      this.redirectTo = null;
    },
    onCancelConfirmChanges() {
      this.showConfirmChanges = false;
      this.redirectTo = null;
    },
    canConfirmBooking,
    canCancelBooking,
    canCompleteBooking,
    canMarkBookingAsNoShow,
    canMarkBookingAsPaid,
    canResendBookingEmail,
    confirmBooking,
    completeBooking,
    noShowBooking,
    markReservationsAsPaid,
    resendNotifications,
    duplicateBooking,
    canDownloadVoucher,
    canDownloadQuote,
    calculateHoursDifference,
    cancelBooking,
    getAirportDetails,
    getFlightType,
    getAirportName,
    getFormatDate,
    getFormatTime,
    fromValidationMessage,
    toValidationMessage,
    dealNumberValidationMessage,
    formatPaymentType,
    formatPassengerType,
    formatServiceCategory,
    formatTransferType,
    formatClientType,
    formatTransportTypeLabel,
    passengerCountValidationMessage,
    childSeatsCountValidationMessage,
    formatBookingDate,
    formatBookingTime,
    canCancelQuote,
    canConvertQuote,
    canDownloadQuotePDF,
    canDuplicateQuote,
    cancelQuote,
    convertToBooking,
    deleteQuote,
    downloadQuotePDF,
    duplicateQuote,
    getSourceOrigin,
    getServiceProvider,
    getResponsibleName,
    getResponsiblePosition,
    getIcon,
    getHeaderPassengerTable,
    getTitleByGender,
    getAdjustmentsStatus,
    parsePrice,
    getCustomerLabel,
    getSelectServices,
    getUnitTime,
    // <<<<<<<<<<<<<<<<<<<< General Helpers >>>>>>>>>>>>>>>>>>>>
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    // <<<<<<<<<<<<<<<<<<<< Location Methods >>>>>>>>>>>>>>>>>>>>
    async getLocationFrom(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = getTypeLocation(this.reservation.type, "from");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsFrom = locations;
          } else {
            this.optionsFrom = [];
          }
        } else {
          this.optionsFrom = [];
        }
      } catch (error) {
        this.optionsFrom = [];
      }
    },
    async getLocationTo(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = getTypeLocation(this.reservation.type, "to");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsTo = locations;
          } else {
            this.optionsTo = [];
          }
        } else {
          this.optionsTo = [];
        }
      } catch (error) {
        this.optionsTo = [];
      }
    },
    async populateOringData(from) {
      if (from) {
        let element = this.optionsFrom.find(item => item.select === from);
        if (element) {
          this.country_code = element.country_code;
          if (element.type === "airport") {
            this.originData = element;
            this.reservation.originData = element;
            this.flightType = "ARRIVAL";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.originData = element.place_id ? element : null;
            this.reservation.originData = this.originData;
          }
        }
      }
    },
    async populateDestinationData(to) {
      if (to) {
        let element = this.optionsTo.find(item => item.select === to);
        if (element) {
          if (element.type === "airport") {
            this.destinationData = element;
            this.reservation.destinationData = element;
            this.flightType = "DEPARTURE";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.destinationData = element.place_id ? element : null;
            this.reservation.destinationData = this.destinationData;
          }
        }
      }
    },
    async selectFrom(from) {
      await this.populateOringData(from);
      await this.getRatesWithTheOrigin(from);
    },
    async selectTo(to) {
      await this.populateDestinationData(to);
      await this.getRatesWithTheDestination(to);
    },
    // <<<<<<<<<<<<<<<<<<<< Quotation Methods >>>>>>>>>>>>>>>>>>>>
    buildRateOptionsRequestBody() {
      return {
        passengersCount: this.reservation.passengersCount,
        origin: getOriginData(
          this.originData,
          this.reservation.from,
          this.reservation.type
        ),
        destination: getDestinationData(
          this.destinationData,
          this.reservation.to,
          this.reservation.type
        ),
        pickup_date: this.reservation.pickup_date,
        pickup_time: this.reservation.pickup_time,
        type_request: this.requestType,
        arrival: this.flightType === "ARRIVAL",
        hours: this.reservation.number_hourly,
        childSeatsCount: 0,
        serviceType: this.product ? "EXPERIENCE" : "TRANSFER",
        source: "rhombus-v1"
      };
    },
    async getBookingOptions() {
      if (this.product) {
        let payload = this.buildProductOptionsRequestBody();
        let productId = this.product._id;
        await this.getBookingProductOptions(productId, payload);
        return;
      } else {
        let payload = this.buildRateOptionsRequestBody();
        await this.getAvailableRateOptions(payload);
        return;
      }
    },
    buildProductOptionsRequestBody() {
      return {
        passengers: this.reservation.passengersCount,
        origin: getPoint(
          this.product.transfer.type === "ARRIVAL",
          this.originData,
          this.reservation.from
        ),
        destination: getPoint(
          this.product.transfer.type === "DEPARTURE",
          this.destinationData,
          this.reservation.to
        ),
        pickupDate: this.reservation.pickup_date,
        pickupTime: this.reservation.pickup_time,
        transferType: this.product.type === "TOUR" ? "HOURLY" : "JOURNEY",
        journeyType: this.product.transfer.type,
        operatorId: this.product.supplier.ref,
        branchId: this.product.branch.ref,
        optionId: this.product.service.ref,
        areaId: this.product.area.ref,
        duration: this.product.duration.value,
        showOptions: this.product.show_options,
        source: "rhombus-v1"
      };
    },
    async getBookingProductOptions(productId, payload) {
      try {
        this.loaderService = "SEARCHING";
        let {
          data
        } = await TransferPricingAPI.getTransferPricingProductQuotation(
          productId,
          payload,
          this.sesion.token
        );
        let rates = data || [];
        this.all_services = rates;
        this.services = rates;
        this.serviceAux = this.services;
        this.suppliersOptions = this.supplier ? [this.supplier] : [];
        this.branchesOptions = this.branch ? [this.branch] : [];
        this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
        return;
      } catch (error) {
        this.all_services = [];
        this.services = [];
        this.serviceAux = [];
        this.loaderService = "NOT_FOUND";
        return;
      } finally {
        if (this.services.length === 0) {
          this.service = null;
          this.reservation.service = null;
        }
        return;
      }
    },
    async getAvailableRateOptions(payload) {
      try {
        this.loaderService = "SEARCHING";
        let { data } = await TransferPricingAPI.getTransferPricingQuotation(
          payload,
          this.sesion.token
        );
        if (data) {
          this.branchFilter = "";
          this.supplierFilter = "";
          this.reservation.locations.from = data.origin;
          this.reservation.locations.to = data.destination;
          this.reservation.distancematrix.distance = data.distance;
          this.reservation.distancematrix.duration = data.duration;
          this.timezone = data.timezone;
          this.all_services = data.all_services;
          this.services = data.services;
          this.serviceAux = this.services;
          this.suppliersOptions = data.suppliers;
          this.drivers = data.drivers;
          this.branchesOptions = data.branches;
          this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
          return;
        } else {
          this.all_services = [];
          this.services = [];
          this.serviceAux = [];
          this.suppliersOptions = [];
          this.branchesOptions = [];
          this.loaderService = "NOT_FOUND";
          return;
        }
      } catch (error) {
        this.all_services = [];
        this.services = [];
        this.serviceAux = [];
        this.suppliersOptions = [];
        this.branchesOptions = [];
        this.loaderService = "NOT_FOUND";
        return;
      } finally {
        if (this.services.length === 0) {
          this.service = null;
          this.reservation.service = null;
        }
        return;
      }
    },
    async getRatesWithTheOrigin(value) {
      try {
        if (!this.onLoad) {
          const isRequotable = canBeRequoted(
            this.reservation.type,
            value,
            this.reservation.to,
            this.reservation.pickup_date,
            this.reservation.pickup_time,
            this.reservation.number_hourly,
            this.reservation.passengersCount
          );
          if (isRequotable) {
            this.debouncedRequote();
          }
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheDestination(value) {
      try {
        if (!this.onLoad) {
          const isRequotable = canBeRequoted(
            this.reservation.type,
            this.reservation.from,
            value,
            this.reservation.pickup_date,
            this.reservation.pickup_time,
            this.reservation.number_hourly,
            this.reservation.passengersCount
          );
          if (isRequotable) {
            this.debouncedRequote();
          }
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupDate(value) {
      try {
        if (!this.onLoad) {
          const isRequotable = canBeRequoted(
            this.reservation.type,
            this.reservation.from,
            this.reservation.to,
            value,
            this.reservation.pickup_time,
            this.reservation.number_hourly,
            this.reservation.passengersCount
          );
          if (isRequotable) {
            this.debouncedRequote();
          }
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupTime(value) {
      try {
        if (!this.onLoad) {
          const isRequotable = canBeRequoted(
            this.reservation.type,
            this.reservation.from,
            this.reservation.to,
            this.reservation.pickup_date,
            value,
            this.reservation.number_hourly,
            this.reservation.passengersCount
          );
          if (isRequotable) {
            this.debouncedRequote();
          }
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheNumberPassengers(value) {
      if (!this.onLoad) {
        try {
          const passengersCount = parseInt(value);
          const isRequotable = canBeRequoted(
            this.reservation.type,
            this.reservation.from,
            this.reservation.to,
            this.reservation.pickup_date,
            this.reservation.pickup_time,
            this.reservation.number_hourly,
            passengersCount
          );
          if (isRequotable && passengersCount > 0) {
            this.debouncedRequote();
          }
        } catch (error) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `Please verify your Address / Date & Time information.`,
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    async getRatesWithTheHourly(value) {
      try {
        const quotedHours = parseInt(value);
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          quotedHours,
          this.reservation.passengersCount
        );
        if (isRequotable && quotedHours > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async requote() {
      if (isRequoteBlockedByStatus(this.reservationStatus)) return;
      this.requoteStatus = "RECALCULATED";
      this.showRates = true;
      this.branchFilter = "";
      this.supplierFilter = "";
      this.suppliersOptions = [];
      this.branchesOptions = [];
      this.branchesAux = [];
      if (this.isRequoteNeeded) {
        this.reservation.service = null;
        this.service = null;
      }
      await this.getBookingOptions();
      let serviceId = this.service ? this.service._id : null;
      let currentService = getServiceById(serviceId, this.services);
      if (!currentService) {
        const fromAll = getServiceById(serviceId, this.all_services);
        if (fromAll) {
          this.services.unshift(fromAll);
          this.serviceAux = this.services;
          currentService = fromAll;
        }
      }
      if (currentService) {
        this.processServiceSelection(currentService);
      } else {
        this.reservation.service = null;
        this.service = null;
      }
      this.requoteStatus = "CALCULATED";
    },
    // <<<<<<<<<<<<<<<<<<<< Service Selection Methods >>>>>>>>>>>>>>>>>>>>
    changeSupplier(value) {
      if (value !== "") {
        this.branchFilter = "";
        this.branchesAux = this.branchesOptions.filter(branch => {
          return branch.supplier === value;
        });
        this.serviceAux = this.all_services.filter(service => {
          return this.branchesAux
            .map(branch => branch._id)
            .includes(service.branchId);
        });
      } else {
        this.branchFilter = "";
        this.serviceAux = this.services;
      }
    },
    changeBranch(value) {
      if (value !== "") {
        this.serviceAux = this.all_services.filter(service => {
          return service.branchId === value;
        });
      } else {
        if (this.supplierFilter) {
          this.branchesAux = this.branchesOptions.filter(branch => {
            return branch.supplier === this.supplierFilter;
          });
          this.serviceAux = this.all_services.filter(service => {
            return this.branchesAux
              .map(branch => branch._id)
              .includes(service.branchId);
          });
        }
      }
    },
    handlePriceChange(confirmed, service) {
      if (confirmed) {
        this.applyServiceToReservation(service, this.customer);
        return;
      }
    },
    async handleBlackoutService(confirmed, service) {
      if (confirmed) {
        await this.handleServiceSelection(service);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleCutOff(confirmed, service) {
      if (confirmed) {
        await this.applyServiceToReservation(service, this.customer);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleServiceSelection(service) {
      if (this.service) {
        const isDifferentServiceId = this.service._id !== service._id;
        if (isDifferentServiceId) {
          await this.validateAndApplyService(service);
          return;
        }
        const samePriceComposition = isSamePriceComposition(
          this.service.basePriceComposition,
          service.basePriceComposition
        );
        const sameSurchargesComposition = isSameSurchargesComposition(
          this.service.surcharges,
          service.surcharges
        );

        if (!samePriceComposition || !sameSurchargesComposition) {
          await this.validateAndApplyService(service);
          return;
        }
        return;
      }
      await this.validateAndApplyService(service);
      return;
    },
    async processServiceSelection(service) {
      try {
        if (service.blackout) {
          await handleBlackoutConfirmation(service, this.handleBlackoutService);
        } else {
          await this.handleServiceSelection(service);
        }
      } catch (error) {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async validateAndApplyService(service) {
      const { isCutoffTimeApplied } = service;
      if (isCutoffTimeApplied) {
        await handleCutOffConfirmation(service, this.handleCutOff);
        return;
      }

      await this.applyServiceToReservation(service, this.customer);
      return;
    },
    async applyServiceToReservation(service, customer) {
      this.service = service;
      this.reservation.surcharges = service.surcharges;
      this.driver = driverAssign(
        this.driver,
        this.reservation.branch,
        service.branchId
      );
      this.driverId = this.driver ? this.driverId : null;
      this.driverEdit = this.driverId ? "view" : "edit";
      this.reservation.driver = this.driverId;
      if (this.driverId === null) {
        this.reservation.chauffeur = {
          name: "",
          email: "",
          phone: "",
          gender: ""
        };
      }

      this.reservation.supplier = service.supplierId;
      this.reservation.branch = service.branchId;
      this.reservation.service = service._id;
      this.reservation.vehicle = service.vehicle._id;

      this.reservation.pricing.reason_adjustment = "";

      let base_price = parseFloat(service.base_price.toFixed(2));
      this.reservation.pricing.base_price.amount = base_price;
      this.reservation.pricing.base_price.last_amount = base_price;
      this.reservation.pricing.base_price.composition =
        service.basePriceComposition;

      let sale_price = parseFloat(service.sale_price.toFixed(2));
      this.reservation.pricing.sale_price.amount = sale_price;
      this.reservation.pricing.sale_price.last_amount = sale_price;

      let base_price_amount = calculateTotalPrice(
        base_price,
        service.surcharges,
        "net"
      );
      let net_price = parseFloat(base_price_amount.toFixed(2));
      this.reservation.pricing.net_price.amount = net_price;
      this.reservation.pricing.net_price.last_amount = net_price;

      this.currency.symbol = service.currency.symbol;
      this.currency.code = service.currency.code;
      if (customer) {
        this.calculePriceByCustomer(
          this.reservation.pricing.net_price.last_amount,
          customer.mark_up,
          customer.type_markup,
          true
        );
      }
      this.driversOptions = await this.getDriverOptions(
        this.reservation.branch
      );
    },
    getBranchName(branchId) {
      let branch = this.branchesOptions.find(branch => branch._id === branchId);
      if (branch) {
        return branch.name;
      } else {
        return "Destination Name";
      }
    },
    getSupplierName(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.businessDetails.name;
      }
      return "Supplier Name";
    },
    getSupplierNotes(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.publicNotes;
      }
      return "";
    },
    // <<<<<<<<<<<<<<<<<<<< Customer Methods >>>>>>>>>>>>>>>>>>>>
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().includes(input.trim().toLowerCase()) ||
              customer.company_name.toLowerCase().includes(input.toLowerCase())
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    copyDataCustomer() {
      let passengersCount = this.reservation.passengers.length;
      if (passengersCount >= 0 && passengersCount <= 1) {
        this.reservation.passengers = [
          {
            _id: null,
            reference: uuidv4(),
            firstName: this.customer.first_name,
            lastName: this.customer.last_name,
            fullName: `${this.customer.first_name} ${this.customer.last_name}`,
            email: this.customer.email,
            phone: this.customer.phone,
            gender: this.customer.gender,
            type: "ADULT",
            primary: true,
            notify: this.customer.email ? true : false,
            flightNumber: this.reservation.flight_number
          }
        ];
        this.reservation.pickupSign.format = "CUSTOM";
        this.reservation.pickupSign.text = `${this.getTitleByGender(
          this.customer.gender
        )} ${this.customer.first_name} ${this.customer.last_name}`;
      }
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.customerId = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status) {
        this.reservation.customer = this.customer._id;
      }
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (!this.service) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected any available service.`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
          this.customerId = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          let customer = this.customer;
          this.copyData = true;
          if (["travel_access"].includes(customer.type)) {
            this.reservation.customer = customer.owner;
            this.reservation.agent = customer._id;
          } else {
            this.reservation.customer = customer._id;
            this.reservation.agent = null;
          }
          this.calculePriceByCustomer(
            parseFloat(
              this.reservation.pricing.net_price.last_amount.toFixed(2)
            ),
            customer ? customer.mark_up : 0,
            customer ? customer.type_markup : "",
            customer ? true : false
          );
        }
        this.passengers = await this.getPassengersByCustomerId(customerId);
      } else {
        this.copyData = false;
      }
    },
    async checkIfCreditPaymentApplies(customer, pricing, serviceCurrencyCode) {
      const { credit, currency, type } = customer;
      if (credit && credit.status && pricing) {
        if (isPartner(type)) {
          let grossPrice = pricing.totals.gross_price;
          let priceService = await calculateGroosPrice(
            grossPrice,
            serviceCurrencyCode,
            currency.code
          );
          return credit.available >= priceService;
        }
      }
      return false;
    },
    async changePaymentType(value) {
      if (value === "credit") {
        const hasCreditAvailable = await this.checkIfCreditPaymentApplies(
          this.customer,
          this.reservation.pricing,
          this.service.currency.code
        );
        if (!hasCreditAvailable) {
          this.reservation.payment_type = "card";
        }
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Pricing & Adjustments Methods >>>>>>>>>>>>>>>>>>>>
    calculePriceByCustomer(netPrice, markUp, markUpType, customerExists) {
      let grossPrice = getGroosPrice(
        netPrice,
        markUp,
        markUpType,
        customerExists
      );

      let totalGrossPrice = calculateTotalPrice(
        parseFloat(grossPrice.toFixed(2)),
        this.reservation.surcharges,
        "gross"
      );
      this.reservation.pricing.gross_price.amount = parseFloat(
        totalGrossPrice.toFixed(2)
      );

      this.reservation.pricing.gross_price.last_amount = this.reservation.pricing.gross_price.amount;

      let netProfit =
        this.reservation.pricing.gross_price.last_amount - netPrice;
      this.reservation.pricing.net_profit.amount = parseFloat(
        netProfit.toFixed(2)
      );
      this.reservation.pricing.net_profit.last_amount = this.reservation.pricing.net_profit.amount;

      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
    },
    populatePricing(extras = [], discounts = []) {
      //Calculate Total Extras Net Price
      this.reservation.pricing.totals.extras.net_price = calculateTotalExtrasNetPrice(
        extras
      );
      //Calculate Total Extra Gross Price
      this.reservation.pricing.totals.extras.gross_price = calculateTotalExtraGrossPrice(
        extras
      );
      //Calculate Total Extras Net Profit
      this.reservation.pricing.totals.extras.net_profit =
        this.reservation.pricing.totals.extras.gross_price -
        this.reservation.pricing.totals.extras.net_price;

      //Calculate Total Discounts
      this.reservation.pricing.totals.discounts = calculateTotalDiscounts(
        discounts
      );

      //Calculate Total Net Price
      this.reservation.pricing.totals.net_price = calculateTotalNetPrice([
        this.reservation.pricing.totals.extras.net_price,
        this.reservation.pricing.net_price.last_amount
      ]);

      //Calculate Total Gross Price
      let totalsGrossPrice = calculateTotalGrossPrice([
        this.reservation.pricing.totals.extras.gross_price,
        this.reservation.pricing.gross_price.last_amount
      ]);
      this.reservation.pricing.totals.gross_price =
        totalsGrossPrice - this.reservation.pricing.totals.discounts;

      //Calculate Commissions Platform
      this.reservation.commissions.platform.percentage = getCommissionByCustomer(
        this.customer
      );

      this.reservation.commissions.platform.amount = calculateCommissionAmount(
        this.reservation.pricing.totals.gross_price,
        this.reservation.commissions.platform.percentage
      );

      //Calculate Total Net profit
      this.reservation.pricing.totals.net_profit = calculateTotalNetProfit(
        this.reservation.pricing.totals.gross_price,
        this.reservation.pricing.totals.net_price,
        this.reservation.commissions.platform.amount,
        this.reservation.commissions.payment_processor.amount
      );
    },
    addAdjustments(adjustment) {
      if (adjustment === "extraCharges") {
        this.openExtrasModal();
      } else if (adjustment === "discounts") {
        this.openDiscountModal();
      } else {
        this.openPriceAdjustments();
      }
    },
    openDiscountModal() {
      this.showDiscountModal = true;
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
    },
    manageDiscounts(discounts = []) {
      this.reservation.pricing.discounts = discounts;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showDiscountModal = false;
    },
    openExtrasModal() {
      this.showExtrasModal = true;
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
    },
    manageExtras(extras = []) {
      this.reservation.pricing.extras = extras;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showExtrasModal = false;
    },
    openPriceAdjustments() {
      this.lastGrossPrice = this.reservation.pricing.gross_price.last_amount;
      this.lastNetPrice = this.reservation.pricing.net_price.last_amount;
      this.showPriceAdjusments = true;
    },
    closePriceAdjusments() {
      this.lastGrossPrice = 0;
      this.lastNetPrice = 0;
      this.showPriceAdjusments = false;
    },
    managePriceAdjusments(pricing) {
      let { netProfit, grossPrice, netPrice, reason } = pricing;
      this.reservation.pricing.net_price.last_amount = netPrice;
      this.reservation.pricing.gross_price.last_amount = grossPrice;
      this.reservation.pricing.net_profit.last_amount = netProfit;
      this.reservation.pricing.reason_adjustment = reason;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showPriceAdjusments = false;
    },

    // <<<<<<<<<<<<<<<<<<<< Passenger Methods >>>>>>>>>>>>>>>>>>>>

    closeNewPassengerModal(status) {
      this.showNewPassengerModal = false;
    },
    closeEditPassengerModal() {
      this.showEditPassengerModal = false;
      this.tempPassenger = null;
      this.passengerIndex = null;
    },
    openEditPassengerModal(passenger, passengerIdentifier) {
      this.showEditPassengerModal = true;
      this.tempPassenger = passenger;
      this.passengerIndex = passengerIdentifier;
    },
    addNewPassenger() {
      if (
        this.reservation.passengers.length < this.reservation.passengersCount
      ) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          this.showNewPassengerModal = true;
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    async removePassenger(index, primary) {
      if (!primary) {
        let { value } = await Swal.fire({
          title: "Remove Passenger",
          html:
            "Are you sure you want to <strong>Remove</strong> the selected Passenger?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          this.reservation.passengers.splice(index, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The PAX has been removed",
            icon: "flaticon-check-3"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You cannot delete a PAX marked as primary. To delete this PAX, please assign another PAX as the primary.",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async sendNotificationToPassengers(passengers = []) {
      let isCompleted = passengers.every(passenger => passenger.email);
      if (isCompleted) {
        let { value } = await Swal.fire({
          title: "Send Notification",
          html:
            passengers.length === 1
              ? "Are you sure you want to <strong>send</strong> a notification to this PAX?"
              : "Are you sure you want to <strong>send</strong> a notification to these PAX?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendNotificationByReservationId(
            this.reservationId,
            passengers
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Send Notification!",
          message:
            "You are trying to send a notification to one or more PAX without an associated email.",
          icon: "flaticon-warning-1"
        });
      }
    },
    async sendNotificationByReservationId(reservationId, passengers = []) {
      try {
        let { data } = await ReservationsAPI.sendNotificationByReservationId(
          reservationId,
          passengers,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notification has been sent",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}\nEmail: ${passenger.email}\n`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    makePassengerAsDefault(index) {
      if (index >= 0) {
        this.reservation.passengers = this.reservation.passengers.map(
          passenger => {
            passenger.primary = false;
            return passenger;
          }
        );
        this.reservation.passengers[index].primary = true;
        if (this.reservation.pickupSign.format === "CUSTOM") {
          this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
            this.reservation.passengers
          );
        }
      }
    },
    async addPassenger(passenger) {
      if (passenger) {
        if (this.reservation.passengers.length === 0) {
          passenger.primary = true;
          passenger.notify = passenger.email ? true : false;
          this.reservation.passengers.push(passenger);
          this.reservation.pickupSign.format = "CUSTOM";
          this.reservation.pickupSign.text = `${this.getTitleByGender(
            passenger.gender
          )} ${passenger.firstName} ${passenger.lastName}`;
        } else {
          this.reservation.passengers.push(passenger);
        }
        this.passengers = passenger._id
          ? await this.getPassengersByCustomerId(this.customerId)
          : this.passengers;
      }
    },
    upadtePassenger(passenger) {
      if (passenger) {
        this.reservation.passengers.splice(this.passengerIndex, 1, passenger);
        if (this.reservation.pickupSign.format === "CUSTOM") {
          this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
            this.reservation.passengers
          );
        }
      }
      this.passengerIndex = 0;
      this.tempPassenger = null;
    },
    async getPassengersByCustomerId(customerId) {
      try {
        let { data } = await PassengersAPI.getPassengersByCustomerId(
          customerId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    importPassengers() {
      let passengersCount = this.reservation.passengersCount;
      if (this.reservation.passengers.length < passengersCount) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          confirmImportPassengers(() => this.$refs.fileInput.click());
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    bulkPassengers(event) {
      try {
        const [file] = event.target.files;
        if (file) {
          this.readFile(file);
          this.$refs.fileInput.value = null;
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the import again",
            icon: "flaticon-warning-1"
          });
          this.$refs.fileInput.value = null;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The PAX data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
        this.$refs.fileInput.value = null;
      }
    },
    readFile(file) {
      try {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: async results => {
            let headers = results.meta.fields;
            let content = parseContentFile(results.data);
            let isValidFile =
              !validateHeadersFile(headers) && validateContentFile(content);
            let passengersCount = this.reservation.passengersCount;
            let diffPassengers =
              passengersCount - this.reservation.passengers.length;
            if (diffPassengers > 0 && content.length <= diffPassengers) {
              if (isValidFile) {
                let localPassengers = getPassengerToRegister(
                  this.reservation.passengers,
                  parsePassengers(content)
                );
                if (this.reservation.passengers.length === 0) {
                  localPassengers[0].primary = true;
                }

                this.reservation.passengers.push(...localPassengers);
                if (this.reservation.pickupSign.format === "CUSTOM") {
                  this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
                    this.reservation.passengers
                  );
                }
                let bulkPassengers = getPassengerToRegister(
                  this.passengers,
                  parsePassengers(content)
                );
                if (bulkPassengers.length) {
                  let registeredPassengers = await this.bulkCreatePassengers(
                    bulkPassengers,
                    this.customer._id,
                    this.customer.type
                  );
                  this.updatePassengerIdentifier(registeredPassengers);
                  this.passengers = await this.getPassengersByCustomerId(
                    this.customerId
                  );
                }
                this.$notify({
                  type: "success",
                  title: "Success!",
                  message: "PAX data has been imported successfully",
                  icon: "flaticon-check-3"
                });
              } else {
                this.$notify({
                  type: "warning",
                  title: "Warning!",
                  message:
                    "There is an error in the imported file, please check the data and try the import again",
                  icon: "flaticon-warning-1"
                });
              }
            } else {
              this.$notify({
                type: "warning",
                title: "Important!",
                message:
                  "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
                icon: "flaticon-warning-1"
              });
            }
          }
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The PAX data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async bulkCreatePassengers(passengers = [], customerId, customerType) {
      try {
        let { data } = await PassengersAPI.bulkCreatePassengers(
          passengers,
          customerId,
          customerType,
          this.sesion.token
        );
        if (data.status) {
          return data.data.passengers;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    updatePassengerIdentifier(passengers = []) {
      this.reservation.passengers = this.reservation.passengers.map(
        passenger => {
          let element = passengers.find(
            item =>
              item.email === passenger.email && item.phone === passenger.phone
          );
          if (element) {
            passenger._id = element._id;
          }
          return passenger;
        }
      );
    },
    // <<<<<<<<<<<<<<<<<<<< Pickup Sign Methods >>>>>>>>>>>>>>>>>>>>
    async uploadPickupSign(event) {
      this.$refs.pickupSign.click();
    },
    async readPickupSign(event) {
      this.reservation.pickupSign.text = "";
      this.reservation.pickupSign.format = "FILE";
      await this.uploadPickupSignFile(event);
    },
    async uploadPickupSignFile(event) {
      try {
        const [file] = event.target.files;
        if (file && file.type === "application/pdf") {
          if (file.size > 2 * 1024 * 1024) {
            event.preventDefault();
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The file can't be larger than 2MB",
              icon: "flaticon-remove"
            });
            this.clearfile();
          } else {
            this.pdfDataUrl = URL.createObjectURL(file);
            let fileData = FileService.generateResourceData(
              "/uploads/pdf/signs",
              file.name
            );
            let queryString = FileService.buildQueryString(fileData);
            let urlFile = await FileService.uploadResource(file, queryString);
            if (urlFile) {
              this.reservation.pickupSign.link = urlFile;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message:
                  "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
                icon: "flaticon-remove"
              });
            }
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the upload again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The file couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearfile() {
      this.pdfDataUrl = null;
      this.reservation.pickupSign = getPickupSignByPrimaryPassenger(
        this.reservation.passengers
      );
    },
    openPreviewPickup() {
      this.showPreviewPickupSign = true;
    },
    closePreviewPickupSign(status) {
      this.showPreviewPickupSign = status;
      this.pdfDataUrl = null;
    },
    // <<<<<<<<<<<<<<<<<<<< Transfer Type / Reference Methods >>>>>>>>>>>>>>>>>>>>
    changeRouterReference(value) {
      this.routerReference = {
        transferType: this.reservation.type,
        value
      };
    },
    changeReservationTransferType(type) {
      let routerReferenceValue = getRouterReferenceValue(
        type,
        this.routerReference
      );
      if (["arrival", "departure"].includes(type)) {
        this.requestType = "one_way";
        this.reservation.flight_number = routerReferenceValue;
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "station") {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = routerReferenceValue;
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "port") {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = routerReferenceValue;
        this.reservation.number_hourly = 0;
      } else if (type === "hourly") {
        this.requestType = "hourly";
        this.reservation.to = "";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = routerReferenceValue;
      } else {
        this.requestType = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Flight Methods >>>>>>>>>>>>>>>>>>>>
    async getFlightsInformationByIdent(ident) {
      if (!this.isFlightType || !ident || this.loaderVerifyFlight) return;
      this.loaderVerifyFlight = true;
      try {
        let { data } = await FlightsAPI.getFlightsInformationByIdent(
          ident,
          this.sesion.token
        );
        if (data.status) {
          window.open(
            `https://www.flightaware.com/live/flight/${data.data.ident}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We couldn't display the details of your flight. Please try again later.`,
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We couldn't display the details of your flight. Please try again later.`,
          icon: "flaticon-warning-1"
        });
      }
      this.loaderVerifyFlight = false;
    },
    async handleFlightSelection(payload) {
      const { flight, isAdjustingDateTime, flightType } = payload;
      this.flight = flight;
      this.flight.isAdjustingDateTime = isAdjustingDateTime;
      this.flight.flightType = flightType;
      this.reservation.flight = cloneDeep(flight);
      this.changeRouterReference(this.reservation.flight_number);
      if (isAdjustingDateTime) {
        const date =
          flightType === "ARRIVAL" ? flight.arrivaltime : flight.departuretime;
        const timezone =
          flightType === "ARRIVAL"
            ? flight.destination.timezone
            : flight.origin.timezone;

        this.reservation.pickup_date = getPickupDate(date, timezone);
        if (flightType === "ARRIVAL") {
          this.reservation.pickup_time = getPickupTime(date, timezone);
        }
        this.$notify({
          type: "info",
          title: "Important!",
          message: generateMessageToNotify(flightType),
          icon: "flaticon-notification-bell-outline-interface-symbol"
        });
        await this.requote();
      }
    },
    /**
     * Handle flight validation rules
     * @param {Object} rules - The flight validation rules
     */
    handleValidationState(rules) {
      this.flightValidationRoles = { ...rules };
    },
    /**
     * Reset flight details when flight number input changes
     */
    onFlightNumberInput(flightNumber) {
      if (!flightNumber) {
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Driver Methods >>>>>>>>>>>>>>>>>>>>
    addDriversInOptions(driver) {
      if (driver) {
        this.driversOptions.push(driver);
        this.driverId = driver._id;
        this.reservation.driver = this.driverId;
        this.driver = populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
      }
      this.showAddModalDriver = false;
    },
    updateDriversInOptions(driver) {
      if (driver) {
        this.driversOptions = this.driversOptions.filter(
          e => e._id !== driver._id
        );
        this.driversOptions.push(driver);
        this.driverId = driver._id;
        this.reservation.driver = this.driverId;
        this.driver = populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
      }
      this.showEditModalDriver = false;
    },
    closeNewDriverModal(status) {
      this.showAddModalDriver = false;
    },
    closeEditDriverModal(status) {
      this.showEditModalDriver = false;
    },
    async getDriverOptions(branchId) {
      try {
        let { data } = await ReservationsAPI.getDriversByBranchId(
          branchId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectDriver(driverId) {
      let driver = this.driversOptions.find(driver => driver._id === driverId);
      if (driver) {
        this.reservation.driver = driverId;
        this.driver = populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
      } else {
        this.reservation.chauffeur = {
          name: "Local RhomTrip Supplier",
          email: this.supplier.authentication.email,
          phone: getContactNumber(
            true,
            this.supplier.contactPerson.phoneNumbers
          ),
          gender: ""
        };
        this.driverEdit = "edit";
        this.driver = null;
        this.driverId = null;
        this.reservation.driver = null;
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Request Recipients Methods >>>>>>>>>>>>>>>>>>>>
    requestRecipients() {
      this.openRequestRecipientsModal();
    },
    openRequestRecipientsModal() {
      this.showRequestRecipients = true;
    },
    closeRequestRecipientsModal(status) {
      this.showRequestRecipients = status;
    },
    populateRecipients(payload) {
      let { recipients, reason } = payload;
      this.beforeUpdate(recipients, reason, this.customer, this.route);
      this.closeRequestRecipientsModal(false);
    },
    // <<<<<<<<<<<<<<<<<<<< Record Loading Methods >>>>>>>>>>>>>>>>>>>>
    async loadReservation(reservationId) {
      try {
        let { data } = await ReservationsAPI.getReservation(reservationId);
        if (data.status) {
          let reservation = data.data;
          this.stage = reservation.stage;
          this.confirmationReason = reservation.confirmationReason || null;
          this.reservationStatus = reservation.status;
          this.paymentStatus = reservation.payment_status;
          this.paymentMethod = reservation.payment_method;
          this.requestType =
            reservation.type !== "hourly" ? "one_way" : "hourly";
          this.updateStatus = reservation.status_update;
          this.createdAt = reservation.created_at;
          this.timezone = reservation.branch.timezone;
          this.pickupDate = reservation.pickup_date;
          this.isProcessing = reservation.isProssesing;
          this.bookingType = reservation.class;
          this.reservation.payment_reference = reservation.payment_reference;

          this.booking_number = reservation.booking_number;
          this.isFirstBooking = reservation.isFirstBooking === true;
          this.reservation.booking_reference = reservation.booking_reference;
          this.reservation.source = reservation.source;
          this.reservation.utcExpiresAt = reservation.utcExpiresAt;

          /** Flight Info */
          this.flight = reservation.flight
            ? cloneDeep(reservation.flight)
            : null;
          this.reservation.flight = this.flight;

          /**Address / Date & Time */
          this.reservation.locations.to = reservation.locations.to;

          this.reservation.locations.from = reservation.locations.from;

          this.reservation.distancematrix.distance =
            reservation.distancematrix.distance;
          this.reservation.distancematrix.duration =
            reservation.distancematrix.duration;

          this.reservation.originData = reservation.originData
            ? reservation.originData
            : null;
          this.reservation.destinationData = reservation.destinationData
            ? reservation.destinationData
            : null;
          this.originData = this.reservation.originData;
          this.destinationData = this.reservation.destinationData;
          this.reservation.type = reservation.type;
          this.optionsFrom = populateFromOptions(
            reservation.from,
            this.reservation.type,
            this.originData
          );
          if (reservation.to) {
            this.optionsTo = populateToOptions(
              reservation.to,
              this.reservation.type,
              this.destinationData
            );
          }
          this.reservation.to = reservation.to;
          this.reservation.from = reservation.from;
          /** */
          this.reservation.pickup_date = moment(reservation.pickup_date)
            .utc(false)
            .format("YYYY-MM-DD");

          this.reservation.pickup_time = reservation.pickup_time;
          this.reservation.passengersCount = reservation.passengersCount;
          this.reservation.childSeatsCount = reservation.childSeatsCount
            ? reservation.childSeatsCount
            : 0;
          this.reservation.number_hourly = reservation.number_hourly;
          this.reservation.number_stations = reservation.number_stations;
          this.reservation.cruise_line = reservation.cruise_line;

          /** Flight Number */
          this.reservation.flight_number = reservation.flight_number;
          this.flightType = getFlightType(this.reservation.type);
          this.airport = this.getAirportDetails(
            this.reservation.type,
            this.optionsFrom,
            this.optionsTo
          );

          this.routerReference = getRouterReference(
            this.reservation.type,
            this.reservation.flight_number,
            this.reservation.number_stations,
            this.reservation.cruise_line,
            this.reservation.number_hourly
          );
          /**Add driver in reservation */
          this.driversOptions = await this.getDriverOptions(
            reservation.branch._id
          );
          if (reservation.driver !== null) {
            let driverId = reservation.driver._id;
            this.driver = populateDriver(reservation.driver);
            let isDriverInclude = this.driversOptions
              .map(driver => driver._id)
              .includes(driverId);
            if (!isDriverInclude) {
              this.driversOptions.push(this.driver);
            }
            this.driverId = driverId;
            this.reservation.driver = driverId;
            this.reservation.chauffeur = {
              name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
              email: this.driver.account.email,
              phone: this.driver.person.numbre_phone,
              gender: this.driver.person.gender
            };
          } else {
            this.reservation.driver = null;
            this.reservation.chauffeur = cloneDeep(reservation.chauffeur);
          }
          this.driverEdit = this.driverId ? "view" : "edit";
          /**Service / Supplier */
          /**Add  Supplier in reservations */
          this.reservation.supplier = reservation.supplier._id;
          this.supplierFilter = reservation.supplier._id;
          this.suppliersOptions.push(reservation.supplier);
          this.supplier = reservation.supplier;

          /**Add branch in reservations */
          this.branchFilter = reservation.branch._id;
          this.branchesAux.push(reservation.branch);
          this.branchesOptions.push(reservation.branch);
          this.reservation.branch = reservation.branch._id;
          this.branch = reservation.branch;

          /**Add service in reservations */
          this.reservation.service = reservation.service._id;

          let vehicle = reservation.service.vehicle;
          this.reservation.vehicle = vehicle._id;

          this.service = populateService(reservation, vehicle);
          if (this.service) {
            this.cancellationPolicy = reservation.service.cancellationPolicy;
          }

          this.serviceAux.push(this.service);
          this.services.push(this.service);

          this.reservation.surcharges = reservation.surcharges;
          this.currency.symbol = this.service.currency.symbol;
          this.currency.code = this.service.currency.code;

          /**Add Customer in reservations */

          this.reservation.passenger = reservation.passenger;
          this.initCustomer(reservation.customer, reservation.agent);

          this.product = populateProduct(reservation.product);
          this.reservation.product = reservation.product
            ? reservation.product._id
            : null;

          /** */
          this.reservation.payment_type = reservation.payment_type;
          this.reservation.passengers = reservation.passengers
            ? reservation.passengers
            : [];

          /** Price and Fee*/
          this.reservation.pricing.net_price = cloneDeep(
            reservation.pricing.net_price
          );
          this.reservation.pricing.base_price = cloneDeep(
            reservation.pricing.base_price
          );
          this.reservation.pricing.gross_price = cloneDeep(
            reservation.pricing.gross_price
          );
          this.reservation.pricing.net_profit = cloneDeep(
            reservation.pricing.net_profit
          );
          this.reservation.pricing.sale_price = cloneDeep(
            reservation.pricing.sale_price
          );
          this.reservation.pricing.discounts = cloneDeep(
            reservation.pricing.discounts
          );
          this.reservation.pricing.extras = cloneDeep(
            reservation.pricing.extras
          );

          this.reservation.commissions = cloneDeep(reservation.commissions);

          this.reservation.pricing.totals = cloneDeep(
            reservation.pricing.totals
          );
          this.reservation.pricing.reason_adjustment =
            reservation.pricing.reason_adjustment;

          this.oldGrossPrice = this.reservation.pricing.totals.gross_price;

          this.reservation.invoice_number = reservation.invoice_number;
          this.reservation.pickupSign = reservation.pickupSign;
          this.pdfDataUrl =
            this.reservation.pickupSign.format === "FILE" &&
            this.reservation.pickupSign.link
              ? this.reservation.pickupSign.link
              : null;
          this.reservation.special_requirements =
            reservation.special_requirements;
          this.reservation.deal_number = reservation.deal_number;
          this.reservation.event =
            (reservation.event && reservation.event._id) ||
            reservation.event ||
            null;
          this.passengers = await this.getPassengersByCustomerId(
            this.customerId
          );
          this.reservation.notificaition = reservation.notificaition;
          this.paymentLinkStatus = reservation.paymentLink.status;
          this.paymentLink = reservation.paymentLink.url;
          this.responsibleName = getResponsibleName(reservation.responsible);
          this.responsiblePosition = getResponsiblePosition(
            reservation.responsible
          );
          this.reservation.owner = reservation.owner;
          this.reservation.metadata = reservation.metadata
            ? reservation.metadata
            : {};
          this.reservationCopy = cloneDeep(this.reservation);
          this.serviceCopy = cloneDeep(this.service);
          await this.getPendingChange(reservationId);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    initCustomer(customer, agent) {
      if (customer) {
        if (customer.type === "travel_agency") {
          if (agent) {
            let agentId = getAgentId(agent);
            this.reservation.agent = agentId;
            let ifExist = getCustomerById(this.customers, agentId);
            if (ifExist === undefined) {
              this.customers.push(populateAgent(agent, customer));
            }
            this.customerId = agentId;
          } else {
            let ifExist = getCustomerById(this.customers, customer._id);
            if (ifExist === undefined) {
              this.customers.push(populateCustomer(customer));
            }
            this.customerId = customer._id;
          }
        } else {
          let ifExist = getCustomerById(this.customers, customer._id);
          if (ifExist === undefined) {
            this.customers.push(populateCustomer(customer));
          }
          this.customerId = customer._id;
        }
        this.reservation.customer = customer._id;
        this.customers = alphabeticallySort(this.customers);
        this.customer = getCustomerById(this.customers, this.customerId);
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Record Saving Methods >>>>>>>>>>>>>>>>>>>>
    storeReservation(redirectTo = null) {
      if (this.isAvailabilityRequestPending) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: EDIT_BLOCKED_REASONS.AVAILABILITY_REQUEST_PENDING,
          icon: "flaticon-warning-1"
        });
        return;
      }

      if (this.pendingChange) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `The reservation cannot be updated having pending changes. Please contact support.`,
          icon: "flaticon-warning-1"
        });
        return;
      }

      if (this.requoteStatus === "CALCULATED") {
        if (this.stage === "QUOTE") {
          this.validateRecord(
            { redirectTo, customer: this.customer },
            this.saveQuote
          );
          return;
        }

        if (this.stage === "RESERVATION") {
          this.validateRecord(
            { redirectTo, customer: this.customer },
            this.persistReservation
          );
          return;
        }
      }

      this.$notify({
        type: "warning",
        title: "Important!",
        message: `The reservation cannot be updated as it is currently being re-quoted for transfer.`,
        icon: "flaticon-warning-1"
      });
      return;
    },
    validateRecord(params, callback) {
      if (!this.$v.reservation.$invalid) {
        callback(params);
      } else {
        this.$v.reservation.$touch();
        if (this.$v.reservation.passengersCount.$invalid) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `The number of PAX does not match the number of PAX added to the list.`,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes.",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    async saveQuote({ redirectTo = null, customer = null } = {}) {
      let notChanged = isEqual(this.reservation, this.reservationCopy);
      if (notChanged) {
        this.$router.push("/reservations");
        return;
      }

      if (
        this.reservationStatus === "CANCELLED" ||
        this.reservationStatus === "REJECTED"
      ) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `This quote can't be updated since it was cancelled or rejected.`,
          icon: "flaticon-warning-1"
        });
        return;
      }

      let quote = cloneDeep(this.reservation);
      quote.pickup_date = buildUtcPickupDateTime(
        quote.pickup_date,
        quote.pickup_time
      );
      await this.updateQuote(this.reservationId, quote, redirectTo);
    },
    async updateQuote(quoteId, quote, redirectTo = null) {
      try {
        this.onSave = false;
        this.setLoad(true);
        let { data } = await QuotesAPI.updateQuoteById(
          quoteId,
          quote,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quotes has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(redirectTo ? redirectTo : "/reservations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving your quote, please try again"
        );
      }
    },
    async persistReservation({ redirectTo = null, customer = null } = {}) {
      try {
        this.setLoad(true);

        if (!hasChanges(this.reservation, this.reservationCopy)) {
          this.$router.push("/reservations");
          return;
        }

        if (this.reservationStatus === "EXPIRED") {
          this.$notify({
            type: "warning",
            title: "Re-Quoted!",
            message: `The quote period for this reservation has expired. You can resume the reservation once it has been re-quoted.`,
            icon: "flaticon-warning-1"
          });
          return;
        }

        const originalDetails = toTransferDetails(
          this.reservationCopy,
          this.serviceCopy
        );
        const requestedDetails = toTransferDetails(
          this.reservation,
          this.service
        );
        const needsConfirmation = requiresChangeConfirmation(
          this.reservationStatus,
          originalDetails,
          requestedDetails
        );
        if (needsConfirmation) {
          this.redirectTo = redirectTo;
          this.originalDetails = originalDetails;
          this.requestedDetails = requestedDetails;
          this.showConfirmChanges = true;
          return;
        }

        await this.saveReservation({ redirectTo, customer });
      } finally {
        this.setLoad(false);
      }
    },
    async saveReservation({ redirectTo = null, customer = null } = {}) {
      try {
        this.setLoad(true);

        this.route = redirectTo;
        const canNotify = !["JF", "SBC", "SCB", "BI", "PNDG"].includes(
          this.reservationStatus
        );
        if (canNotify) {
          const hasNoChanges = hasChanges(
            this.reservation,
            this.reservationCopy,
            ["driver", "chauffeur", "event"]
          );
          if (hasNoChanges) {
            this.requestRecipients();
            return;
          }
          const recipients = ["AGENT", "CUSTOMER", "PASSENGER"];
          this.beforeUpdate(recipients, "", customer, redirectTo);
          return;
        }
        this.beforeUpdate([], "", customer, redirectTo);
      } finally {
        this.setLoad(false);
      }
    },
    async beforeUpdate(recipients, reason, customer, redirectTo = null) {
      let reservation = cloneDeep(this.reservation);
      reservation.pickup_date = buildUtcPickupDateTime(
        reservation.pickup_date,
        reservation.pickup_time
      );

      let paymentDecision = null;
      let isInProcess = !["BI", "SBC", "SCB", "JF"].includes(
        this.reservationStatus
      );
      const isPriceChanged =
        this.oldGrossPrice !== reservation.pricing.totals.gross_price;
      const isConsideredPaid = ["UNPAID", "PARTIALLY_PAID"].includes(
        this.paymentStatus
      );
      const needsCreditCheck = isPriceChanged || isConsideredPaid;
      const isCreditPaymentMethod = reservation.payment_type === "credit";
      const hasStarted = !["BI", "PNDG", "EXPIRED"].includes(
        this.reservationStatus
      );
      let captureMode = CAPTURE_MODE_IMMEDIATE;
      if (isCreditPaymentMethod && isInProcess && needsCreditCheck) {
        const hasCreditAvailable = await this.checkIfCreditPaymentApplies(
          customer,
          reservation.pricing,
          this.service.currency.code
        );
        if (!hasCreditAvailable) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Insufficient credit available. Please check the customer's credit balance or select a different payment method.",
            icon: "flaticon-warning-1"
          });
          return;
        }
        if (isPriceChanged && hasStarted) {
          captureMode = CAPTURE_MODE_DEFERRED;
        }
        paymentDecision = await this.resolveCreditPayment(
          customer,
          reservation.payment_type,
          hasCreditAvailable
        );
      }

      const updateContext = { recipients, reason };
      await this.updateReservation(
        this.reservationId,
        reservation,
        updateContext,
        {
          isPayConfirmed: paymentDecision
            ? paymentDecision.isPayConfirmed
            : false,
          currencyCode: paymentDecision ? paymentDecision.currencyCode : null,
          paymentMethod: paymentDecision ? PAYMENT_METHOD.CREDIT : null,
          captureMode: paymentDecision ? captureMode : null,
          customerId: paymentDecision ? paymentDecision.customerId : null,
          redirectTo
        }
      );
    },
    async updateReservation(id, reservation, updateContext, paymentContext) {
      try {
        const { recipients, reason } = updateContext;
        let { data } = await ReservationsAPI.updateReservation(
          id,
          { reservation, recipients: recipients, reason: reason },
          this.sesion.token
        );
        this.onSave = true;
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }

        this.reservationCopy = cloneDeep(this.reservation);
        this.serviceCopy = cloneDeep(this.service);
        if (paymentContext.isPayConfirmed) {
          paymentContext.ids = [data._id];
          await this.processReservationPayment(data, paymentContext);
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Saved",
          icon: "flaticon-check-3"
        });

        this.$router.push(
          paymentContext.redirectTo || { path: "/reservations" }
        );
      } catch (error) {
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    async recalculateExpiredReservation() {
      this.mode = "edit";
      await this.requote();
    },
    async detectChanges(to, from, next) {
      const hasReservationChanges = hasChanges(
        this.reservation,
        this.reservationCopy
      );

      if (
        !this.canUserUpdate ||
        !hasReservationChanges ||
        this.sigout ||
        this.onSave
      ) {
        next();
        return;
      }

      let { value, dismiss } = await Swal.fire({
        title: "Important",
        html:
          "The Reservation has been modified,<br>Do you want to <strong>save changes</strong>?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        this.storeReservation(to.path);
        return;
      }
      if (dismiss === Swal.DismissReason.cancel) {
        next();
        return;
      }
      next(false);
    },
    // <<<<<<<<<<<<<<<<<<<< Payment Methods >>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    async processReservationPayment(reservation, paymentContext) {
      const {
        currencyCode,
        paymentMethod,
        captureMode,
        customerId,
        ids,
        redirectTo
      } = paymentContext;

      try {
        const payload = this.buildPaymentPayload(
          ids,
          currencyCode,
          paymentMethod,
          captureMode,
          customerId
        );
        const paymentResult = await this.payReservations(payload);

        if (!paymentResult) {
          this.notifyPaymentFailed(paymentContext.redirectTo);
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Saved and Paid",
          icon: "flaticon-check-3"
        });
        this.$router.push(
          paymentContext.redirectTo || { path: "/reservations" }
        );
      } catch (error) {
        this.notifyPaymentFailed(paymentContext.redirectTo);
      }
    },
    buildPaymentPayload(
      ids,
      currencyCode,
      paymentMethod,
      captureMode,
      customerId
    ) {
      return {
        method: paymentMethod,
        customerId: customerId,
        currency: currencyCode,
        captureMode: captureMode,
        ids: ids,
        action: "UPDATE"
      };
    },
    notifyPaymentFailed(redirectTo) {
      this.$notify({
        type: "warning",
        title: "Reservation Saved",
        message:
          "The reservation was saved, but the payment could not be processed. Please try paying again from the reservation detail.",
        icon: "flaticon-warning-1"
      });
      this.$router.push(redirectTo || { path: "/reservations" });
    },
    async payReservations(payload) {
      try {
        const { data } = await PaymentsAPI.payReservations(
          payload,
          this.sesion.token
        );
        return data || null;
      } catch (error) {
        if (isUnauthorizedError(error)) {
          this.setSigOut(true);
        }
        return null;
      }
    },
    async getReservationPaymentSummaries(ids = []) {
      if (!Array.isArray(ids) || ids.length === 0) return null;
      try {
        const { data } = await PaymentsAPI.getPaymentSummaries(
          { reservationIds: ids },
          this.sesion.token
        );
        return data || [];
      } catch (error) {
        if (isUnauthorizedError(error)) {
          this.setSigOut(true);
        }
        return [];
      }
    },
    // <<<<<<<<<<<<<<<<<<<< Booking Action Handlers >>>>>>>>>>>>>>>>>>>>
    async handlerSendPaymentLink(bookings, client, callback) {
      const ids = bookings.map(booking => booking._id);
      const reservationPaymentSummaries = await this.getReservationPaymentSummaries(
        ids
      );
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to request payment for one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to request payment for one or more reservations which have been cancelled"
        },
        {
          check: hasPendingCapturePayment,
          message:
            "You are trying to request payment for one or more reservations which are pending capture payment. Please wait until the payment has been captured before proceeding."
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to request payment for one or more reservations with an expired rate. Please recalculate the rates for these pending reservations before sending the payment link."
        },
        {
          check: hasDraftBookings,
          message:
            "You are trying to request payment for one or more reservations that have not been completed"
        },
        {
          check: isSameUserForAllBookings,
          message: "Selected reservations must have the same customer name"
        },
        {
          check: () => bookings.length > 15,
          message:
            "You can only send payment links for a maximum of 15 reservations at a time."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(reservationPaymentSummaries)) {
          this.$notify({
            type: "warning",
            title: "Payment link could not be sent!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }

      let userId = client ? client._id : null;
      let userRole = client ? client.type : null;
      if (!userId && !userRole) {
        this.$notify({
          type: "warning",
          title: "User Identification Error",
          message:
            "An error occurred while identifying the user. Please try again.",
          icon: "flaticon-warning-1"
        });
        return;
      }

      let payload = {
        userId: userId,
        userRole: userRole,
        reservations: reservationPaymentSummaries.map(
          reservationPaymentSummary => reservationPaymentSummary.id
        )
      };
      await sendPaymentLink(payload, callback);
    },
    async sendPaymentLinkToCustomer(payload) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.sendPaymentLink(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.send) {
          await this.loadReservation(this.reservationId);
          this.$notify({
            type: "success",
            title: "Payment Link Sent!",
            message:
              "Your payment email link has been sent to customer successfully",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Payment link was not sent!",
            message: "Please contact support via email",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "Please contact support via email",
          "Payment link was not sent!"
        );
      }
    },
    async handlerCancelReservation(
      bookingId,
      pickupDate,
      timeZone,
      cancellationPolicy,
      callback
    ) {
      const utcNow = moment.tz(timeZone).utc(true);
      let refundEligibility = resolveRefundEligibility(
        utcNow,
        pickupDate,
        cancellationPolicy
      );
      await this.cancelBooking(bookingId, refundEligibility, callback);
    },
    async cancelBookingById(bookingId, reason) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.canlcelReservationById(
          bookingId,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Cancelled",
          icon: "flaticon-check-3"
        });
        await this.loadReservation(bookingId);
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async confirmBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confirmReservationById(
          bookingId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Confirmed",
          icon: "flaticon-check-3"
        });
        await this.loadReservation(bookingId);
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async updateBookingStatus(bookingId, status, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.changeRservationStatus(
          bookingId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.loadReservation(bookingId);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been updated successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be updated. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async duplicateBookingById(bookingId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/reservations/new?recordId=${bookingId}`);
    },
    async handlerMarkReservationsAsPaid(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to pay one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to pay one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to pay one or more reservations with an expired rate."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "The Reservations cannot be Paid!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      const payload = {
        line_items: bookings.map(booking => {
          return {
            unit_id: booking._id
          };
        }),
        reason: "Payment marked as paid by admin"
      };
      await markReservationsAsPaid(payload, callback);
    },
    async markReservationsAsPaidById(payload) {
      try {
        this.setLoad(true);
        let { data } = await PaymentsAPI.markReservationsAsPaid(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Paid",
            icon: "flaticon-remove"
          });
          return;
        }
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservations has been Paid",
          icon: "flaticon-check-3"
        });
        await this.loadReservation(this.reservationId);
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Paid");
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Voucher(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    /**
     * Quotes Methods
     */
    async convertQuoteToBookingById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.createBookingFromQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const { _id: id } = data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been converted to a Booking",
            icon: "flaticon-check-3"
          });
          this.$router.push(`/reservations/${id}`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be converted to a Booking",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote cannot be converted to a Booking");
      }
    },
    async downloadQuoteById(quoteId, quoteNumber) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.downloadQuotePDFById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Quote(${quoteNumber}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async duplicateQuoteById(quoteId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/reservations/new-quote?recordId=${quoteId}`);
    },
    async cancelQuoteById(quoteId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.cancelQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been cancelled",
            icon: "flaticon-check-3"
          });
          this.loadReservation(quoteId);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote can't be cancelled");
      }
    },
    async deleteQuoteById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.deleteQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been deleted",
            icon: "flaticon-check-3"
          });
          this.$router.push("/reservations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote can't be deleted",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    /**
     * Flight Methods
     */

    /**
     * Handle flight selection and update reservation details
     * @param {Object} payload - The flight selection payload
     */
    // <<<<<<<<<<<<<<<<<<<< Vuex Bindings >>>>>>>>>>>>>>>>>>>>
    async resolveCreditPayment(customer, paymentType, hasCreditAvailable) {
      if (!customer || !paymentType) return null;

      const { _id: customerId, type: customerType, currency } = customer;
      const isPartnerCustomer = isPartner(customerType);

      if (paymentType === "credit" && hasCreditAvailable && isPartnerCustomer) {
        return {
          isPayConfirmed: true,
          currencyCode: currency.code,
          customerId: customerId
        };
      }
      return null;
    },
    async onPendingChangeCancelled() {
      this.showPendingChangeModal = false;
      await this.getPendingChange(this.reservationId);
      this.paymentSummaryKey++;
    },
    async getPendingChange(reservationId) {
      const pendingChange = await this.getPendingChangeByReservationId(
        reservationId
      );
      this.pendingChange = pendingChange ? pendingChange : null;
    },
    async getPendingChangeByReservationId(id) {
      try {
        const { data } = await ReservationsAPI.getPendingChangeByReservationId(
          id,
          this.sesion.token
        );
        return data ? data : null;
      } catch (error) {
        console.error("Error fetching pending change:", error);
        return null;
      }
    },
    ...mapActions(["getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread"
    ])
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [MessageBox.name]: MessageBox,
    [Message.name]: Message,
    flatPicker,
    VueTelInput,
    WSelect,
    AddCustomer,
    ProductCard: ProductCard,
    RequestRecipients,
    ReservationHistory,
    ReservationPaymentSummary,
    PendingChangeModal,
    ConfirmChanges,
    PaymentStatus: PaymentStatus,
    FirstBookingBadge: FirstBookingBadge,
    TransferStatusBadge,
    TransportReference,
    AddDrivers: AddDrivers,
    EditDrivers: EditDrivers,
    NewPassenger,
    EditPassenger,
    Services,
    FadeTransition,
    Charges,
    ManageExtraCharges,
    ManageDiscounts,
    ManagePriceAdjustments,
    FlightNumberInput,
    FlightDetails
  },
  validations: {
    reservation: {
      from: {
        required
      },
      to: {
        required: requiredIf(function(value) {
          return this.reservation.type !== "hourly";
        }),
        differentFromPickup: function(value) {
          if (this.reservation.type === "hourly") return true;
          return value !== this.reservation.from;
        }
      },
      pickup_date: {
        required
      },
      pickup_time: {
        required
      },
      passengersCount: {
        required,
        numeric,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(85),
        customValidator: function(value) {
          return this.reservation.passengers.length <= value;
        }
      },
      customer: {
        required,
        alphaNum
      },
      service: {
        required
      },
      number_hourly: {
        required: requiredIf(function() {
          return this.reservation.type === "hourly";
        }),
        minValue: function(value) {
          if (this.reservation.type !== "hourly") return () => true;
          return value > 1;
        }
      },
      number_stations: {
        maxLength: maxLength(45)
      },
      cruise_line: {
        maxLength: maxLength(45)
      },
      flight_number: {
        required: requiredIf(function(value) {
          return false;
        }),
        isFlightValid(value) {
          if (["arrival", "departure"].includes(this.reservation.type)) {
            if (!value) return true;
            const regex = /^[A-Z0-9]{1,3}?\d{1,5}[A-Z]?$/i;
            return regex.test(value.trim());
          }
          return true;
        },
        isValidate(value) {
          if (["arrival", "departure"].includes(this.reservation.type)) {
            let flightType = this.flightValidationRoles.flightType;
            if (["ARRIVAL", "DEPARTURE"].includes(flightType)) {
              return this.flightValidationRoles.isValidateFlightNumber;
            }
          }
          return true;
        }
      },
      deal_number: {
        maxLength: maxLength(10),
        customValidator: function(value) {
          if (value) {
            const regex = /^[A-Za-z]{3}-\d{5,6}$/;
            return regex.test(value);
          }
          return true;
        }
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      pricing: {
        net_price: {
          last_amount: {
            required,
            decimal,
            minValue: minValue(1)
          }
        },
        gross_price: {
          last_amount: {
            required,
            decimal,
            minValue: minValue(1)
          }
        }
      },
      childSeatsCount: {
        numeric,
        integer,
        maxValue: maxValue(10)
      }
    }
  },
  computed: {
    editBlockedReason() {
      if (this.isAvailabilityRequestPending) {
        return EDIT_BLOCKED_REASONS.AVAILABILITY_REQUEST_PENDING;
      }
      if (this.pendingChange) return EDIT_BLOCKED_REASONS.PENDING_CHANGE;
      return null;
    },
    isAvailabilityRequestPending() {
      return (
        this.stage === "QUOTE" && QUOTE_TYPES.includes(this.confirmationReason)
      );
    },
    availabilityRequestNotice() {
      return RESERVATION_NOTICES.AVAILABILITY_REQUEST_PENDING;
    },
    isPendingChangeAwaitingPayment() {
      return (
        !!this.pendingChange && this.pendingChange.status === "PENDING_PAYMENT"
      );
    },
    pendingChangeNotice() {
      if (!this.pendingChange) return null;
      return this.pendingChange.status === "PENDING_PAYMENT"
        ? RESERVATION_NOTICES.CHANGE_PENDING_PAYMENT
        : RESERVATION_NOTICES.CHANGE_PENDING_CONFIRMATION;
    },
    isFlightType() {
      return ["airport", "arrival", "departure"].includes(
        this.reservation.type
      );
    },
    ...mapGetters([
      "locations",
      "customerOptions",
      "sesion",
      "userRole",
      "load",
      "sigout",
      "itemsBread"
    ]),
    canUserUpdate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CREATE");
    },
    canUserMarkBookingAsPaid() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "MARK_AS_PAID");
    },
    canUserSendPaymentLink() {
      return isUserAuthorized(
        "RESERVATIONS",
        this.userRole,
        "SEND_PAYMENT_LINK"
      );
    },
    canUserChangeStatus() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CHANGE_STATUS");
    },
    passenger() {
      const passengers = this.reservation.passengers;
      let passenger = passengers.find(p => p.primary === true) || passengers[0];
      return {
        gender: passenger ? passenger.gender : "",
        fullName: passenger ? passenger.fullName : "",
        email: passenger ? passenger.email : "",
        phone: passenger ? passenger.phone : ""
      };
    },
    isRequoteNeeded() {
      return this.reservationStatus === "EXPIRED";
    }
  },
  beforeDestroy() {
    if (this.pdfDataUrl) {
      URL.revokeObjectURL(this.pdfDataUrl);
    }
  }
};
</script>
